<template>
  <div>
    <div v-if="loadingOverlay === true">
      <div class="lds-dual-ring"></div>
    </div>

    <div v-if="candidateData !== null">
      <div class="row"></div>

      <div :value="displayAlert" :color="alertType">{{ alertMsg }}</div>
      <div class="row" style="margin-left: 10px">
        <p-button outline type="info" size="sm" round @click="$router.go(-1)">
          <i class="fa fa-chevron-circle-left"></i>
          Back
        </p-button>
      </div>
      <div class="row">
        <div class="col-lg-8 col-md-7">
          <div class="card card-user">
            <div class="image">
              <img src="public/static/img/1x1-00000000.png" alt />
            </div>
            <div class="card-body">
              <div class="author">
                <a
                  :href="
                    'https://instagram.com/' + candidateData.instagramProfile
                  "
                  target="_blank"
                >
                  <img
                    :src="profileImg"
                    class="influencer-img"
                    @error="
                      profilePicLoadCache(candidateData.fullProfile.profileName)
                    "
                  />
                </a>
                <h5 class="title">{{ candidateData.fullProfile.fullName }}</h5>

                <p class="description">
                  <a
                    :href="
                      'https://instagram.com/' + candidateData.instagramProfile
                    "
                    target="_blank"
                    >@{{ candidateData.instagramProfile }}</a
                  >
                </p>
              </div>
              <p class="description text-center">
                {{ candidateData.fullProfile.bio }}
              </p>
            </div>
            <div class="card-footer">
              <hr />
              <div class="button-container">
                <div class="row">
                  <div
                    class="col-lg-3 col-md-6 col-6 ml-auto"
                    v-if="
                      typeof candidateData.fullProfile.followerCount !==
                        'undefined'
                    "
                  >
                    <h5>
                      {{ candidateData.fullProfile.followerCount }}
                      <br />
                      <small>Followers</small>
                    </h5>
                  </div>
                  <div
                    class="col-lg-4 col-md-6 col-6 ml-auto mr-auto"
                    v-if="
                      typeof candidateData.fullProfile.engagementRate !==
                        'undefined'
                    "
                  >
                    <h5>
                      {{
                        (
                          candidateData.fullProfile.engagementRate * 100
                        ).toFixed(2)
                      }}%
                      <br />
                      <small>ER</small>
                    </h5>
                  </div>
                  <div
                    class="col-lg-4 col-md-6 col-6 ml-auto mr-auto"
                    v-if="
                      typeof candidateData.fullProfile.followingCount !==
                        'undefined'
                    "
                  >
                    <h5>
                      {{ candidateData.fullProfile.followingCount }}
                      <br />
                      <small>Following</small>
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-if="postList !== null">
            <div v-if="postList.length > 0">
              <div class="col-md-12">
                <div class="card">
                  <div
                    class="card-header"
                    style="padding-bottom: 0px; margin-bottom: 0px"
                  >
                    <div>
                      <h5
                        class="title"
                        style="padding-bottom: 0px; margin-bottom: 0px"
                      >
                        Recent Posts
                      </h5>
                      <hr />
                    </div>

                    <div style="top: 0px; right: 10px; position: absolute">
                      <p-button
                        @click="
                          $router.push(
                            `/instagram/content/${candidateData.instagramProfile}`
                          )
                        "
                        style="margin-top: 15px"
                        type="info"
                        link
                        >view all</p-button
                      >
                    </div>
                  </div>

                  <div class="card-body">
                    <div
                      class="post-preview"
                      v-for="post in postList"
                      :key="post.shortcode"
                    >
                      <span v-if="post.cached == true">
                        <img
                          :src="post.imageUrlCache"
                          class="img-row"
                          alt
                          @click="
                            $router.push(`/instagram/post/${post.shortcode}`)
                          "
                        />
                      </span>
                      <span v-else>
                        <img
                          :src="post.imageUrl"
                          class="img-row"
                          alt
                          @click="
                            $router.push(`/instagram/post/${post.shortcode}`)
                          "
                        />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="postList !== null">
            <div v-if="noteList.length > 0">
              <time-line type="simple">
                <time-line-item
                  inverted
                  badge-type="info"
                  badge-icon="nc-icon nc-send"
                  v-for="note in noteList"
                  :key="note._id"
                  style="margin-top: 15px"
                >
                  <!-- <badge slot="header" type="info">Another Title</badge> -->
                  <div slot="content">
                    <div>
                      <span>{{ note.authorName }}</span
                      >&nbsp;
                      <span class="note-date">{{ note.dateString }}</span>
                    </div>
                    <hr />
                    <div>
                      <p>{{ note.text }}</p>
                    </div>

                    <div>
                      <span slot="footer">
                        <div>
                          <p-button
                            link
                            @click="showEditNoteModal(note)"
                            size="sm"
                          >
                            <i class="fa fa-pen"></i> Edit
                          </p-button>
                          <p-button
                            size="sm"
                            link
                            @click="showArchiveNoteConfirm(note._id)"
                          >
                            <i class="fa fa-trash"></i> Delete
                          </p-button>
                        </div>
                      </span>
                    </div>
                  </div>
                </time-line-item>
              </time-line>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-5">
          <div class="row" style="margin-bottom: 10px">
            <div class="text-center">
              <p-button @click="showNoteModal" size="sm" type="success">
                <i class="fas fa-plus-circle"></i>&nbsp; Add Note
              </p-button>
            </div>

            <div class="text-center" v-if="isTeam == true">
              <p-button
                @click="showArchiveCandidateModal"
                size="sm"
                type="danger"
              >
                <i class="fas fa-trash"></i> Archive Influencer
              </p-button>
            </div>
          </div>
          <div style="margin-top: 15px; padding: 15px" class="card">
            <h6 style="margin-top: 0px; font-size: 13px">Tags:</h6>
            <div>
              <tags-input
                element-id="tags"
                v-model="selectedTags"
                :existing-tags="tagList"
                @change="tagSearch"
                @tag-added="tagAdd"
                @tag-removed="tagRemove"
                :typeahead="true"
              ></tags-input>
            </div>
          </div>
          <div class="card" style="margin-top: 10px">
            <div class="row" style="padding-top: 10px; padding-left: 10px">
              <div class="col" style="padding-top: 15px">
                <h6 style="font-size: 13px">Influencer Details:</h6>
              </div>
              <div
                class="col"
                style="text-align: right; padding-top: 10px; padding-right: 25px"
              >
                <div
                  outline
                  round
                  @click="editInfluencerDetailsModal = true"
                  class="icon-button"
                >
                  <i class="fas fa-user-edit"></i>Edit
                </div>
              </div>
            </div>

            <div style="padding: 15px">
              <div>
                <div>
                  <span v-if="influencerFirstName !== null">{{
                    influencerFirstName
                  }}</span
                  >&nbsp;
                  <span v-if="influencerLastName !== null">{{
                    influencerLastName
                  }}</span>
                </div>
                <div v-if="influencerEmail !== null">{{ influencerEmail }}</div>
                <div>
                  <div v-if="influencerAddr1">
                    <h6 style="margin-top: 5px">Address:</h6>
                    <span v-if="influencerAddr1">{{ influencerAddr2 }}</span
                    >,&nbsp;
                    <span v-if="influencerAddr2">{{ influencerAddr2 }}</span>
                  </div>

                  <div v-if="influencerCity">
                    {{ influencerCity }},
                    <span v-if="influencerState">{{ influencerState }}</span
                    >&nbsp;
                    <span v-if="influencerZip">{{ influencerZip }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- DISCOUNT CODES -->
          <div class="card" style="margin-top: 10px" v-if="storeExists == true">
            <div class="row" style="padding-top: 10px; padding-left: 10px">
              <div class="col" style="padding-top: 15px">
                <h6 style="font-size: 13px">Discount Codes:</h6>
              </div>

              <div
                class="col"
                style="text-align: right; padding-top: 10px; padding-right: 25px"
              >
                <div
                  outline
                  round
                  @click="showNewDiscountModal()"
                  class="icon-button"
                >
                  <i class="fas fa-plus-circle"></i> Add
                </div>
              </div>
            </div>
            <div v-if="influencerDiscountList !== null">
              <div v-if="influencerDiscountList.length > 0">
                <el-table :data="influencerDiscountList">
                  <el-table-column label="Code" width="125">
                    <template slot-scope="props">
                      <div style="width: 100%; font-size: 11px">
                        {{ props.row.code }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="Type" width="75">
                    <template slot-scope="props">
                      <div style="width: 100%; font-size: 11px">
                        {{ props.row.type }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="Amount" width="100">
                    <template slot-scope="props">
                      <div style="width: 100%; font-size: 11px">
                        <span v-if="props.row.format == 'fixed_amount'">$</span
                        >{{ Math.abs(props.row.amount)
                        }}<span v-if="props.row.format == 'percentage'">%</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="" style="width: 100px">
                    <template slot-scope="props">
                      <div
                        style="padding: 3px; float: left"
                        class="icon-button"
                        @click="showArchiveDiscountModal(props.row._id)"
                      >
                        <i class="far fa-trash-alt"></i>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div v-else style="padding: 15px">No discount codes.</div>
            </div>
            <div v-else style="padding: 15px">
              <div class="lds-dual-ring"></div>
            </div>
          </div>
          <!-- TRACKING LINKS -->
          <div class="card" style="margin-top: 10px">
            <div class="row" style="padding-top: 10px; padding-left: 10px">
              <div class="col" style="padding-top: 15px">
                <h6 style="font-size: 13px">Tracking Links:</h6>
              </div>
              <div
                class="col"
                style="text-align: right; padding-top: 10px; padding-right: 25px"
              >
                <div
                  outline
                  round
                  @click="showAddTrackingLinkModal()"
                  class="icon-button"
                >
                  <i class="fas fa-plus-circle"></i> Add
                </div>
              </div>
            </div>
            <div v-if="trackingLinkList !== null">
              <div v-if="trackingLinkList.length > 0">
                <el-table :data="trackingLinkList">
                  <el-table-column label="Name" width="100">
                    <template slot-scope="props">
                      <div style="width: 100%; font-size: 11px">
                        {{ props.row.name }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="Url" width="175">
                    <template slot-scope="props">
                      <div style="width: 100%; font-size: 11px">
                        {{ props.row.shortLink }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="" width="80">
                    <template slot-scope="props">
                      <div style="width: 100%; font-size: 14px">
                        <div
                          style="padding: 3px; float: left"
                          @click="showTrackingLinkEditModal(props.row._id)"
                          class="icon-button"
                        >
                          <i class="fas fa-edit"></i>
                        </div>
                        <div
                          style="padding: 3px; float: left; font-size: 14px;"
                          class="icon-button"
                          @click="showArchiveTrackingLinkAlert(props.row._id)"
                        >
                          <i class="far fa-trash-alt"></i>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div v-else style="padding: 15px">No tracking links.</div>
            </div>
            <div v-else style="padding: 15px">
              Loading...
              <div class="lds-dual-ring"></div>
            </div>
          </div>
          <!-- INFLUENCER STATUS -->
          <div class="card">
            <div class="col" style="padding-top: 15px">
              <h6 style="font-size: 13px">Status:</h6>
            </div>
            <div>
              <div v-if="candidateData.status == 'declined'">
                Influencer declined participation
              </div>
              <div v-else-if="candidateData.status == 'rejected'">Rejected</div>
              <div
                v-else-if="candidateData.events.length > 0"
                style="padding: 10px"
              >
                <el-table :data="eventList">
                  <el-table-column label="Action" style="width: 200px">
                    <template slot-scope="props">
                      <div style="width: 100%; font-size: 11px">
                        {{ props.row.name }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="Status">
                    <template slot-scope="props">
                      <div style="width: 100%; font-size: 11px">
                        {{ props.row.status }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label>
                    <template slot-scope="props">
                      <div
                        v-if="
                          props.$index == 0 && props.row.status == 'pending'
                        "
                      >
                        <div v-if="props.row.eventData.type == 'select'">
                          <p-button
                            @click="showEventSelectModal(props.row)"
                            round
                            outline
                            size="sm"
                            ><i class="fas fa-check"></i
                          ></p-button>
                        </div>
                        <div v-if="props.row.eventData.type == 'confirmation'">
                          <p-button
                            @click="showEventConfirmModal(props.row)"
                            round
                            outline
                            size="sm"
                            ><i class="fas fa-check"></i
                          ></p-button>
                        </div>
                        <div v-if="props.row.eventData.type == 'text'">
                          <p-button
                            @click="showEventSelectModal(props.row)"
                            round
                            outline
                            size="sm"
                            >GET ACTION</p-button
                          >
                        </div>
                      </div>
                      <div
                        v-else-if="
                          props.$index == 0 && props.row.status == 'complete'
                        "
                      >
                        {{ props.row.eventInput }}
                      </div>
                      <div
                        v-else-if="
                          props.row.status == 'pending' &&
                            candidateData.events[props.$index - 1].status ==
                              'complete'
                        "
                      >
                        <div v-if="props.row.eventData.type == 'select'">
                          <p-button
                            @click="showEventSelectModal(props.row)"
                            round
                            outline
                            size="sm"
                            ><i class="fas fa-check"></i
                          ></p-button>
                        </div>
                        <div v-if="props.row.eventData.type == 'confirmation'">
                          <p-button
                            @click="showEventConfirmModal(props.row)"
                            round
                            outline
                            size="sm"
                            >CONFIRM</p-button
                          >
                        </div>
                        <div v-if="props.row.eventData.type == 'text'">
                          <p-button
                            @click="showEventSelectModal(props.row)"
                            round
                            outline
                            size="sm"
                            ><i class="fas fa-check"></i
                          ></p-button>
                        </div>
                      </div>
                      <div v-else-if="props.row.status == 'complete'">
                        {{ props.row.eventInput }}
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
          <!-- PAYMENT DETAILS -->
          <div class="card" style="margin-top: 10px">
            <div v-if="paymentDetailList !== null">
              <div class="row" style="padding-top: 10px; padding-left: 10px">
                <div class="col-6" style="padding-top: 15px">
                  <h6 style="font-size: 13px">Campaign Payment:</h6>
                </div>
                <div
                  class="col-6"
                  style="text-align: right; padding-right: 25px; padding-top: 15px"
                >
                  <div
                    class="icon-button"
                    outline
                    round
                    @click="showPaymentDetailCreateModal()"
                    v-if="paymentDetailList.length == 0"
                  >
                    <i class="fas fa-plus-edit"></i> Add
                  </div>
                </div>
              </div>
              <div v-if="paymentDetailList.length > 0">
                <el-table :data="paymentDetailList">
                  <el-table-column label="Amt" width="75">
                    <template slot-scope="props">
                      <div style="width: 100%; font-size: 11px">
                        ${{ props.row.amount }}
                      </div>
                    </template>
                  </el-table-column>

                  <el-table-column label="Freq" width="75">
                    <template slot-scope="props">
                      <div
                        v-if="props.row.frequency == 'monthly'"
                        style="width: 100%; font-size: 11px"
                      >
                        {{ props.row.frequency }}
                      </div>
                      <div
                        v-else-if="props.row.frequency == 'single'"
                        style="width: 100%; font-size: 11px"
                      >
                        one-time
                      </div>
                    </template>
                  </el-table-column>

                  <el-table-column label="Starts" width="90">
                    <template slot-scope="props">
                      <div style="width: 100%; font-size: 11px">
                        {{ props.row.startDateString }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="Ends" width="75">
                    <template slot-scope="props">
                      <div style="width: 100%; font-size: 11px">
                        {{ props.row.endDateString }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="" width="75">
                    <template slot-scope="props">
                      <div style="font-size: 14px; float:left;">
                        <i
                          class="far fa-edit icon-button"
                          @click="showPaymentDetailEditModal(props.row._id)"
                        ></i>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div v-else style="padding: 15px">
              <div class="lds-dual-ring"></div>
            </div>
            <div class="row">
              <div class="col" style="padding-left: 25px; padding-right: 25px;">
                <hr />
              </div>
            </div>

            <div class="row" style="padding-top: 10px; padding-left: 10px">
              <div class="col-6" style="padding-top: 15px">
                <h6 style="font-size: 13px">Requirements:</h6>
              </div>
              <div
                class="col-6"
                style="text-align: right;padding-top: 15px; padding-right: 25px"
              >
                <div
                  class="icon-button"
                  outline
                  round
                  @click="showCreatePaymentModal()"
                >
                  <i class="fas fa-plus-circle"></i> Add
                </div>
              </div>
              <div
                style="padding: 15px; width: 100%;"
                v-if="paymentActionList !== null"
              >
                <div
                  class="row"
                  v-for="paymentAction in paymentActionList"
                  :key="paymentAction._id"
                >
                  <div class="col-8" style="width: 100%; font-size: 11px">
                    {{ paymentAction.count }}
                    <span v-if="paymentAction.placement == 'upload'">
                      {{ paymentAction.placement }}ed
                    </span>
                    <span v-else>
                      {{ paymentAction.placement }}
                    </span>
                    <span v-if="paymentAction.count > 1">
                      <span v-if="paymentAction.contentType == 'any'">
                        videos or images
                      </span>
                      <span v-else> {{ paymentAction.contentType }}s </span>
                    </span>
                    <span v-else>
                      <span v-if="paymentAction.contentType == 'any'">
                        video or image
                      </span>
                      <span v-else>
                        {{ paymentAction.contentType }}
                      </span>
                    </span>
                    <span v-if="paymentAction.platform !== 'ugc ad'">
                      on {{ paymentAction.platform }}
                    </span>
                    <span v-else>
                      for UGC
                    </span>
                  </div>
                  <div class="col-4">
                    <div
                      style="font-size: 14px; float:right; margin-left: 10px; margin-right: 15px;"
                    >
                      <i
                        class="far fa-trash-alt icon-button"
                        @click="showArchivePaymentModal(paymentAction._id)"
                      ></i>
                    </div>
                    <div style="font-size: 14px; float:right;">
                      <i
                        class="far fa-edit icon-button"
                        @click="showUpdatePaymentActionModal(paymentAction._id)"
                      ></i>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else style="padding: 15px">No payment set.</div>
            </div>
          </div>
          <!-- COMMISSION DETAILS -->
          <div class="card" style="margin-top: 10px">
            <div v-if="paymentDetailList !== null">
              <div class="row" style="padding-top: 10px; padding-left: 10px">
                <div class="col-6" style="padding-top: 15px">
                  <h6 style="font-size: 13px">Commission:</h6>
                </div>
                <div
                  class="col-6"
                  style="text-align: right; padding-right: 25px; padding-top: 15px"
                >
                  <div
                    class="icon-button"
                    outline
                    round
                    @click="showCommissionDetailCreateModal()"
                  >
                    <i class="fas fa-plus-edit"></i> Add
                  </div>
                </div>
              </div>
              <div v-if="commissionDetailList.length > 0">
                <el-table :data="commissionDetailList">
                  <el-table-column label="Amount" width="100">
                    <template slot-scope="props">
                      <div style="width: 100%; font-size: 11px">
                        <div
                          v-if="props.row.type == 'percentage'"
                          style="width: 100%; font-size: 11px"
                        >
                          {{ props.row.amount }}% per sale
                        </div>
                        <div v-else style="width: 100%; font-size: 11px">
                          ${{ props.row.amount }} per sale
                        </div>
                      </div>
                    </template>
                  </el-table-column>

                  <el-table-column label="Starts" width="90">
                    <template slot-scope="props">
                      <div style="width: 100%; font-size: 11px">
                        {{ props.row.startDateString }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="Ends" width="75">
                    <template slot-scope="props">
                      <div style="width: 100%; font-size: 11px">
                        {{ props.row.endDateString }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="" width="75">
                    <template slot-scope="props">
                      <div style="font-size: 14px; float:left;">
                        <i
                          class="far fa-edit icon-button"
                          @click="showPaymentDetailEditModal(props.row._id)"
                        ></i>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div v-else style="padding: 15px">
              <div class="lds-dual-ring"></div>
            </div>
          </div>
          <!-- INVITE -->
          <div class="card" style="padding: 15px">
            Campaign Invite Link
            <br />
            <hr />

            https://hq.helloconvo.com/influencer/join/{{
              $route.params.candidateId
            }}
          </div>
        </div>
      </div>

      <modal
        :show.sync="addNoteModal"
        :show-close="false"
        :show-header="false"
        type="mini"
        class="modal-custom"
      >
        <div
          v-if="noteFormAlert == true"
          :value="noteFormAlert"
          :class="noteAlertClass"
        >
          {{ noteFormAlertMsg }}
        </div>
        <h4 class="headline" style="padding-top: 0px; margin-top: 0px">
          Add Note
        </h4>

        <textarea
          label="Add Note"
          name="newNote"
          v-model="newNoteText"
          style="width: 100%"
          class="custom-textarea"
        ></textarea>
        <br />
        <div v-if="isTeam == true">
          <div>
            <p>Note Type:</p>
            <select v-model="newNoteType" class="custom-select">
              <option value selected>select note type</option>
              <option
                v-for="option in noteTypeOptions"
                :value="option"
                :key="option"
              >
                {{ option }}
              </option>
            </select>
          </div>
          <div>
            <p>Vibility Type:</p>
            <select v-model="newNoteVisibilityType" class="custom-select">
              <option value selected>select visibility</option>
              <option
                v-for="visibility in noteVisiblityOptions"
                :value="visibility"
                :key="visibility"
              >
                {{ visibility }}
              </option>
            </select>
          </div>
        </div>

        <div style="text-align: center">
          <div style="margin-left: auto; margin-right: auto">
            <p-button
              round
              type="success"
              text
              @click="submitNote"
              style="margin: 10px"
              size="sm"
              >Yes</p-button
            >
            <p-button
              round
              text
              @click="closeNoteModal"
              style="margin: 10px"
              size="sm"
              >Cancel</p-button
            >
          </div>
        </div>
      </modal>

      <!-- EDIT NOTE MODAL  -->

      <modal
        :show.sync="editNoteModal"
        :show-close="false"
        :show-header="false"
        type="mini"
        class="modal-custom"
      >
        <div
          v-if="noteFormAlert == true"
          :value="noteFormAlert"
          :class="noteAlertClass"
        >
          {{ noteFormAlertMsg }}
        </div>
        <h4 class="headline" style="padding-top: 0px; margin-top: 0px">
          Edit Note
        </h4>

        <textarea
          label="Edit Note"
          name="editNote"
          v-model="editNoteText"
          style="width: 100%"
          class="custom-textarea"
        ></textarea>
        <br />
        <div v-if="isTeam == true">
          <div>
            <p>Note Type:</p>
            <select v-model="editNoteType" class="custom-select">
              <option value selected>select note type</option>
              <option
                v-for="option in noteTypeOptions"
                :value="option"
                :key="option"
              >
                {{ option }}
              </option>
            </select>
          </div>
          <div>
            <p>Vibility Type:</p>
            <select v-model="editVisibilityType" class="custom-select">
              <option value selected>select visibility</option>
              <option
                v-for="visibility in noteVisiblityOptions"
                :value="visibility"
                :key="visibility"
              >
                {{ visibility }}
              </option>
            </select>
          </div>
        </div>

        <div style="text-align: center">
          <div style="margin-left: auto; margin-right: auto">
            <p-button
              round
              type="success"
              text
              @click="submitEditNote"
              style="margin: 10px"
              size="sm"
              >Yes</p-button
            >
            <p-button
              round
              text
              @click="closeEditNoteModal"
              style="margin: 10px"
              size="sm"
              >Cancel</p-button
            >
          </div>
        </div>
      </modal>

      <!-- ARCHIVE NOTE MODAL -->

      <modal
        :show.sync="archiveNoteConfirm"
        :show-close="false"
        :show-header="false"
        type="mini"
        class="modal-custom"
      >
        <p style="text-align: center">Confirm Delete Note?</p>
        <div style="text-align: center">
          <div style="margin-left: auto; margin-right: auto">
            <p-button
              round
              type="danger"
              text
              @click="submitArchiveNote"
              style="margin: 10px"
              size="sm"
              >Yes, Delete</p-button
            >
            <p-button
              round
              text
              @click="closeArchiveNoteConfirm"
              style="margin: 10px"
              size="sm"
              >Cancel</p-button
            >
          </div>
        </div>
      </modal>

      <!-- ARCHIVE CANDIDATE MODAL -->
      <modal
        :show.sync="archiveCandidateModal"
        :show-close="false"
        :show-header="false"
        type="mini"
        class="modal-custom"
      >
        <p style="text-align: center">
          Confirm Archive @{{ candidateData.instagramProfile }}?
        </p>
        <div style="text-align: center">
          <div style="margin-left: auto; margin-right: auto">
            <p-button
              round
              type="danger"
              text
              @click="submitArchiveCandidate"
              style="margin: 10px"
              size="sm"
              >Yes, Delete</p-button
            >
            <p-button
              round
              text
              @click="closeArchiveCandidateModal"
              style="margin: 10px"
              size="sm"
              >Cancel</p-button
            >
          </div>
        </div>
      </modal>
      <!-- EDIT DETAILS MODAL -->

      <modal
        :show.sync="editInfluencerDetailsModal"
        type="notice"
        class="modal-custom"
      >
        <h5 slot="header" class="modal-title">Edit Influencer Details</h5>
        <fg-input label="First Name:" v-model="influencerFirstName"></fg-input>
        <fg-input label="Last Name:" v-model="influencerLastName"></fg-input>
        <fg-input
          label="Email:"
          v-model="influencerEmail"
          v-validate="modelValidations.influencerEmail"
          name="Influencer Email"
          type="text"
          :error="getError('influencerEmail')"
          required
        ></fg-input>
        <fg-input label="Address 1:" v-model="influencerAddr1"></fg-input>
        <fg-input label="Address 2:" v-model="influencerAddr2"></fg-input>
        <fg-input label="City:" v-model="influencerCity"></fg-input>
        <fg-input label="State:" v-model="influencerState"></fg-input>
        <fg-input label="Zip:" v-model="influencerZip"></fg-input>
        <fg-input label="Country:" v-model="influencerCountry"></fg-input>
        <div style="text-align: center">
          <div style="margin-left: auto; margin-right: auto">
            <p-button
              round
              type="success"
              text
              @click="submitInfluencerDetails"
              style="margin: 10px"
              size="sm"
              >SAVE</p-button
            >
            <p-button
              round
              text
              @click="editInfluencerDetailsModal = false"
              style="margin: 10px"
              size="sm"
              >Cancel</p-button
            >
          </div>
        </div>
      </modal>

      <!-- EVENT MODALS -->

      <modal
        :show.sync="eventSelectModal"
        :show-close="false"
        :show-header="false"
        type="mini"
        class="modal-custom"
      >
        <div v-if="eventFormAlert == true" :class="noteAlertClass">
          {{ eventFormAlertMsg }}
        </div>
        <h4 class="headline" style="padding-top: 0px; margin-top: 0px">
          {{ eventModalLabel }}
        </h4>

        <div>
          <select v-model="eventSelectInput" class="custom-select">
            <option
              v-for="option in eventSelectOptions"
              :value="option"
              :key="option"
            >
              {{ option }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label class="control-label">Add Note (optional)</label>
          <div class>
            <textarea
              class="form-control"
              v-model="eventNote"
              placeholder
              rows="3"
            ></textarea>
          </div>
        </div>
        <br />

        <div style="text-align: center">
          <div style="margin-left: auto; margin-right: auto">
            <p-button
              round
              type="success"
              text
              @click="processEvent"
              style="margin: 10px"
              >SUBMIT</p-button
            >
            <p-button
              round
              text
              @click="closeEventSelectModal"
              style="margin: 10px"
              >Cancel</p-button
            >
          </div>
        </div>
      </modal>
      <modal
        :show.sync="eventConfirmModal"
        :show-close="false"
        :show-header="false"
        type="mini"
        class="modal-custom"
      >
        <div v-if="eventFormAlert == true" :class="noteAlertClass">
          {{ eventFormAlertMsg }}
        </div>
        <h4 class="headline" style="padding-top: 0px; margin-top: 0px">
          {{ eventModalLabel }}
        </h4>
        <label></label>

        <div class="form-group">
          <label class="control-label">Add Note (optional)</label>
          <div class>
            <textarea
              class="form-control"
              v-model="eventNote"
              placeholder
              rows="3"
            ></textarea>
          </div>
        </div>
        <br />

        <div style="text-align: center">
          <div style="margin-left: auto; margin-right: auto">
            <p-button
              round
              type="success"
              text
              @click="processEvent"
              style="margin: 10px"
              >YES</p-button
            >
            <p-button
              round
              text
              @click="closeEventConfirmModal"
              style="margin: 10px"
              >Cancel</p-button
            >
          </div>
        </div>
      </modal>

      <!-- NEW DISCOUNT CODE MODAL  -->
      <modal
        :show.sync="newDiscountModal"
        :show-close="false"
        :show-header="false"
        type="mini"
        class="modal-custom"
      >
        <h4 class="headline" style="padding-top: 0px; margin-top: 0px">
          Add Discount Code
        </h4>

        <div class="form-group">
          <fg-input label="Code:" v-model="discountCode"></fg-input>
          <div style="margin-bottom: 10px">Type:</div>
          <p-radio v-model="discountFormat" label="percentage"
            >Percentage %</p-radio
          >
          <p-radio v-model="discountFormat" label="fixed_amount"
            >Fixed $</p-radio
          >
          <fg-input
            label="Amount:"
            v-model="discountAmount"
            style="margin-top: 10px"
          ></fg-input>
          <div style="margin-bottom: 10px">Used for:</div>
          <p-radio v-model="discountUse" label="gift">Influencer Gift</p-radio>
          <p-radio v-model="discountUse" label="promo"
            >Influencer Promo</p-radio
          >

          <p>
            <span>Discount Start:</span>
          </p>
          <datepicker
            v-model="discountStart"
            placeholder="Select Date:"
            name="discountStart"
            input-class="calendar-input-custom"
            format="M/d/yy"
          ></datepicker>

          <div>
            <span>Discount End:</span>
          </div>
          <div
            class="row"
            style="padding-left: 10px; margin: 0px; padding: 0px"
          >
            <p-radio
              v-model="discountEndType"
              label="ongoing"
              @input="setDiscountEnd('ongoing')"
              >Ongoing</p-radio
            >
            <p-radio
              v-model="discountEndType"
              label="end_date"
              @input="setDiscountEnd('end_date')"
              >End Date</p-radio
            >
          </div>
          <div class="row" style="padding: 15px">
            <datepicker
              placeholder="Select Date:"
              v-if="showEndDate == true"
              v-model="discountEnd"
              name="discountEnd"
              input-class="calendar-input-custom"
              format="M/d/yy"
            ></datepicker>
          </div>
        </div>
        <br />

        <div style="text-align: center">
          <div style="margin-left: auto; margin-right: auto">
            <p-button
              round
              type="success"
              text
              @click="submitDiscountCode"
              style="margin: 10px"
              >SAVE</p-button
            >
            <p-button
              round
              text
              @click="newDiscountModal = false"
              style="margin: 10px"
              >Cancel</p-button
            >
          </div>
        </div>
      </modal>
      <!-- EDIT DISCOUNT CODE MODAL  -->
      <modal
        :show.sync="editDiscountModal"
        :show-close="false"
        :show-header="false"
        type="mini"
        class="modal-custom"
      >
        <div v-if="eventFormAlert == true" :class="noteAlertClass">
          {{ eventFormAlertMsg }}
        </div>
        <h4 class="headline" style="padding-top: 0px; margin-top: 0px">
          {{ eventModalLabel }}
        </h4>
        <label></label>

        <div class="form-group">
          <label class="control-label">Add Note (optional)</label>
          <div class>
            <textarea
              class="form-control"
              v-model="eventNote"
              placeholder
              rows="3"
            ></textarea>
          </div>
        </div>
        <br />

        <div style="text-align: center">
          <div style="margin-left: auto; margin-right: auto">
            <p-button
              round
              type="success"
              text
              @click="processEvent"
              style="margin: 10px"
              >YES</p-button
            >
            <p-button
              round
              text
              @click="closeEventConfirmModal"
              style="margin: 10px"
              >Cancel</p-button
            >
          </div>
        </div>
      </modal>
      <!-- NEW TRACKING LINK MODAL  -->
      <modal
        :show.sync="newTrackingLinkModal"
        type="notice"
        class="modal-custom"
      >
        <div>
          <div
            class="alert alert-dismissible fade show"
            :class="alertType"
            v-if="addTrackingLinkAlert == true"
            style="width: 100%"
          >
            <div
              v-for="alert in addTrackingLinkErrors"
              :key="alert"
              style="width: 100%"
            >
              <button
                type="button"
                aria-hidden="true"
                class="close"
                data-dismiss="alert"
                aria-label="Close"
              >
                <i class="nc-icon nc-simple-remove"></i>
              </button>

              <span>{{ alert }}</span>
            </div>
          </div>
          <h5 class="card-title" style="margin: 0px; margin-bottom: 15px">
            Add Tracking Link:
          </h5>

          <div
            v-if="trackingLinkTemplateList !== null"
            class="typography-line-custom"
          >
            <p>
              <span> Select Template: </span>

              <select
                v-model="trackingLinkTemplate"
                @change="trackingLinkTemplateSelect"
                class="custom-select"
              >
                <option value selected>select one:</option>
                <option
                  v-for="option in trackingLinkTemplateList"
                  :value="option._id"
                  :key="option._id"
                >
                  {{ option.name }}
                </option>
              </select>
            </p>
          </div>
          <div v-else>
            <div
              v-if="trackingLinkTemplateLoading == true"
              class="lds-dual-ring"
            ></div>
          </div>

          <!--<div class="typography-line-custom" style="clear:both;">
              <span>Business Name:</span>
              <p>{{campaignData.business.businessName}}</p>
          </div>-->
          <div class="typography-line-custom">
            <p>
              <span>Tracking Link Name:</span>
              <fg-input
                placeholder="e.g. Main Product Page or Homepage"
                v-model="newLinkName"
                name="linkName"
                type="text"
                required
              ></fg-input>
            </p>
          </div>
          <div class="typography-line-custom">
            <p>
              <span>Landing Page URL:</span>
              <fg-input
                placeholder="e.g. http://brandco.com/landingpage"
                v-model="newLandingPage"
                name="landingPage"
                type="text"
                required
              ></fg-input>
            </p>
          </div>
          <div class="typography-line-custom">
            <p>
              <span>utm_campaign:</span>
              <fg-input
                placeholder
                v-model="newUtmCampaign"
                type="text"
                required
              ></fg-input>
            </p>
          </div>
          <div class="typography-line-custom">
            <p>
              <span>utm_source:</span>
              <fg-input
                placeholder
                v-model="newUtmSource"
                type="text"
                required
              ></fg-input>
            </p>
          </div>
          <div class="typography-line-custom">
            <p>
              <span>utm_medium:</span>
              <fg-input
                placeholder
                v-model="newUtmMedium"
                type="text"
                required
              ></fg-input>
            </p>
          </div>
          <div class="typography-line-custom">
            <p>
              <span>utm_term:</span>
              <fg-input
                placeholder
                v-model="newUtmTerm"
                type="text"
                required
              ></fg-input>
            </p>
          </div>
          <div class="typography-line-custom">
            <p>
              <span>utm_content:</span>
              <fg-input
                placeholder
                v-model="newUtmContent"
                type="text"
                required
              ></fg-input>
            </p>
          </div>

          <div class="row">
            <p-button color="success" class="mr-4" @click="trackingLinkCreate"
              >SAVE</p-button
            >
          </div>
        </div>
      </modal>
      <!-- EDIT TRACKING LINK MODAL  -->
      <modal
        :show.sync="editTrackingLinkModal"
        type="notice"
        class="modal-custom"
      >
        <div>
          <h5 class="card-title" style="margin: 0px">Edit Tracking Link:</h5>

          <hr />
          <div
            class="alert alert-dismissible fade show"
            :class="alertType"
            v-if="addTrackingLinkAlert == true"
            style="width: 100%"
          >
            <div
              v-for="alert in addTrackingLinkErrors"
              :key="alert"
              style="width: 100%"
            >
              <button
                type="button"
                aria-hidden="true"
                class="close"
                data-dismiss="alert"
                aria-label="Close"
              >
                <i class="nc-icon nc-simple-remove"></i>
              </button>

              <span>{{ alert }}</span>
            </div>
          </div>

          <!--<div class="typography-line-custom" style="clear:both;">
              <span>Business Name:</span>
              <p>{{campaignData.business.businessName}}</p>
          </div>-->
          <div class="typography-line-custom">
            <p>
              <span>Tracking Link Name:</span>
              <fg-input
                placeholder="e.g. Main Product Page or Homepage"
                v-model="editLinkName"
                name="linkName"
                type="text"
                required
              ></fg-input>
            </p>
          </div>
          <div class="typography-line-custom">
            <p>
              <span>Landing Page URL:</span>
              <fg-input
                placeholder="e.g. http://brandco.com/landingpage"
                v-model="editLandingPage"
                name="landingPage"
                type="text"
                required
              ></fg-input>
            </p>
          </div>
          <div class="typography-line-custom">
            <p>
              <span>utm_campaign:</span>
              <fg-input
                placeholder
                v-model="editUtmCampaign"
                type="text"
                required
              ></fg-input>
            </p>
          </div>
          <div class="typography-line-custom">
            <p>
              <span>utm_source:</span>
              <fg-input
                placeholder
                v-model="editUtmSource"
                type="text"
                required
              ></fg-input>
            </p>
          </div>
          <div class="typography-line-custom">
            <p>
              <span>utm_medium:</span>
              <fg-input
                placeholder
                v-model="editUtmMedium"
                type="text"
                required
              ></fg-input>
            </p>
          </div>
          <div class="typography-line-custom">
            <p>
              <span>utm_term:</span>
              <fg-input
                placeholder
                v-model="editUtmTerm"
                type="text"
                required
              ></fg-input>
            </p>
          </div>
          <div class="typography-line-custom">
            <p>
              <span>utm_content:</span>
              <fg-input
                placeholder
                v-model="editUtmContent"
                type="text"
                required
              ></fg-input>
            </p>
          </div>

          <div class="row">
            <p-button color="success" class="mr-4" @click="trackingLinkUpdate"
              >SAVE</p-button
            >
          </div>
        </div>
      </modal>

      <!-- ARCHIVE TRACKING LINK MODAL -->
      <modal
        :show.sync="trackingLinkArchiveAlert"
        :show-close="false"
        :show-header="false"
        type="mini"
        class="modal-custom"
      >
        <div
          class="alert alert-dismissible fade show"
          :class="alertType"
          v-if="trackingLinkArchiveAlertErrorMsg !== null"
          style="width: 100%"
        >
          <button
            type="button"
            aria-hidden="true"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
          >
            <i class="nc-icon nc-simple-remove"></i>
          </button>

          <span>{{ trackingLinkArchiveAlertErrorMsg }}</span>
        </div>

        <p style="text-align: center">{{ this.archiveTrackingLinkModalMsg }}</p>
        <div style="text-align: center">
          <div style="margin-left: auto; margin-right: auto">
            <p-button
              round
              type="danger"
              text
              @click="trackingLinkArchive"
              style="margin: 10px"
              size="sm"
              >Yes, Archive</p-button
            >
            <p-button
              round
              text
              @click="trackingLinkArchiveAlert = false"
              style="margin: 10px"
              size="sm"
              >Cancel</p-button
            >
          </div>
        </div>
      </modal>
      <!-- ARCHIVE DISCOUNT MODAL -->
      <modal
        :show.sync="discountArchiveAlert"
        :show-close="false"
        :show-header="false"
        type="mini"
        class="modal-custom"
      >
        <div
          class="alert alert-dismissible fade show"
          :class="alertType"
          v-if="discountArchiveAlertErrorMsg !== null"
          style="width: 100%"
        >
          <button
            type="button"
            aria-hidden="true"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
          >
            <i class="nc-icon nc-simple-remove"></i>
          </button>

          <span>{{ discountArchiveAlertErrorMsg }}</span>
        </div>

        <p style="text-align: center">
          {{ discountArchiveMsg }}
        </p>
        <div style="text-align: center">
          <div style="margin-left: auto; margin-right: auto">
            <p-button
              round
              type="danger"
              text
              @click="discountArchive"
              style="margin: 10px"
              size="sm"
              >Yes, Archive</p-button
            >
            <p-button
              round
              text
              @click="discountArchiveAlert = false"
              style="margin: 10px"
              size="sm"
              >Cancel</p-button
            >
          </div>
        </div>
      </modal>
      <!-- CREATE PAYMENT ACTION MODAL  -->
      <modal
        :show.sync="createPaymentActionModal"
        :show-close="false"
        :show-header="false"
        type="mini"
        class="modal-custom"
      >
        <div v-if="paymentActions !== null">
          <h4 class="headline" style="padding-top: 0px; margin-top: 0px">
            Add Campaign Requirement
          </h4>

          <div class="form-group">
            <div style="margin-bottom: 10px">Platform:</div>
            <select v-model="paymentActions.platform" class="custom-select">
              <option value selected>Social Platform</option>
              <option
                v-for="option in paymentSocialType"
                :value="option"
                :key="option"
              >
                {{ option }}
              </option>
            </select>
            <div style="margin-bottom: 10px">Placement Type:</div>
            <select v-model="paymentActions.placement" class="custom-select">
              <option value selected>Placement</option>
              <option
                v-for="option in paymentPlacementType"
                :value="option"
                :key="option"
              >
                {{ option }}
              </option>
            </select>
            <div style="margin-bottom: 10px">Content Type:</div>
            <select v-model="paymentActions.contentType" class="custom-select">
              <option value selected>Content Type</option>
              <option
                v-for="option in paymentContentType"
                :value="option"
                :key="option"
              >
                {{ option }}
              </option>
            </select>
          </div>
          <fg-input
            label="# of posts:"
            v-model="paymentActions.count"
            style="margin-top: 10px"
          ></fg-input>

          <div style="text-align: center">
            <div style="margin-left: auto; margin-right: auto">
              <p-button
                round
                type="success"
                text
                @click="createPaymentAction"
                style="margin: 10px"
                >SAVE</p-button
              >
              <p-button
                round
                text
                @click="createPaymentActionModal = false"
                style="margin: 10px"
                >Cancel</p-button
              >
            </div>
          </div>
        </div>
      </modal>
      <!-- EDIT PAYMENT ACTION MODAL  -->
      <modal
        :show.sync="updatePaymentActionModal"
        :show-close="false"
        :show-header="false"
        type="mini"
        class="modal-custom"
      >
        <div v-if="paymentActions !== null">
          <h4 class="headline" style="padding-top: 0px; margin-top: 0px">
            EDIT REQUIREMENT
          </h4>

          <div class="form-group">
            <div style="margin-bottom: 10px">Platform:</div>
            <select v-model="paymentActions.platform" class="custom-select">
              <option value selected>Social Platform</option>
              <option
                v-for="option in paymentSocialType"
                :value="option"
                :key="option"
              >
                {{ option }}
              </option>
            </select>
            <div style="margin-bottom: 10px">Placement Type:</div>
            <select v-model="paymentActions.placement" class="custom-select">
              <option value selected>Placement</option>
              <option
                v-for="option in paymentPlacementType"
                :value="option"
                :key="option"
              >
                {{ option }}
              </option>
            </select>
            <div style="margin-bottom: 10px">Content Type:</div>
            <select v-model="paymentActions.contentType" class="custom-select">
              <option value selected>Content Type</option>
              <option
                v-for="option in paymentContentType"
                :value="option"
                :key="option"
              >
                {{ option }}
              </option>
            </select>
          </div>
          <fg-input
            label="# of posts:"
            v-model="paymentActions.count"
            style="margin-top: 10px"
          ></fg-input>

          <div style="text-align: center">
            <div style="margin-left: auto; margin-right: auto">
              <p-button
                round
                type="success"
                text
                @click="updatePaymentAction"
                style="margin: 10px"
                >SAVE</p-button
              >
              <p-button
                round
                text
                @click="updatePaymentActionModal = false"
                style="margin: 10px"
                >Cancel</p-button
              >
            </div>
          </div>
        </div>
      </modal>
      <!-- ARCHIVE PAYMENT ACTION ALERT MODAL -->
      <modal
        :show.sync="archivePaymentActionModal"
        :show-close="false"
        :show-header="false"
        type="mini"
        class="modal-custom"
      >
        <p style="text-align: center">
          Confirm Archive?
        </p>
        <div style="text-align: center">
          <div style="margin-left: auto; margin-right: auto">
            <p-button
              round
              type="danger"
              text
              @click="submitArchivePaymentAction"
              style="margin: 10px"
              size="sm"
              >Yes, Delete</p-button
            >
            <p-button
              round
              text
              @click="archivePaymentActionModal = false"
              style="margin: 10px"
              size="sm"
              >Cancel</p-button
            >
          </div>
        </div>
      </modal>

      <!-- NEW PAYMENT DETAIL MODAL  -->
      <modal
        :show.sync="createPaymentDetailModal"
        :show-close="false"
        :show-header="false"
        type="mini"
        class="modal-custom"
      >
        <h4 class="headline" style="padding-top: 0px; margin-top: 0px">
          Add Payment Detail
        </h4>

        <div class="form-group">
          <fg-input label="Amount:" v-model="paymentDetailAmount"></fg-input>
          <div style="margin-top: 10px;padding: 5px;">Payment Type:</div>
          <div
            class="row"
            style="padding-left: 10px; margin: 0px; padding: 0px"
          >
            <p-radio v-model="paymentDetailFrequency" label="monthly"
              >Monthly</p-radio
            >
            <p-radio
              v-model="paymentDetailFrequency"
              label="single"
              style="margin-left: 10px;"
              >Single</p-radio
            >
          </div>

          <div style="margin-top: 10px;padding: 5px;">
            <span>Start Date:</span>
          </div>
          <datepicker
            v-model="paymentDetailStart"
            placeholder="Select Date:"
            name="discountStart"
            input-class="calendar-input-custom"
            format="M/d/yy"
          ></datepicker>

          <div style="margin-top: 10px;padding: 5px;">
            <span>End Date:</span>
          </div>
          <div
            class="row"
            style="padding-left: 10px; margin: 0px; padding: 0px"
          >
            <p-radio
              v-model="paymentDetailEndType"
              label="ongoing"
              @input="setPaymentDetailEnd('ongoing')"
              >Ongoing</p-radio
            >
            <p-radio
              v-model="paymentDetailEndType"
              label="end_date"
              @input="setPaymentDetailEnd('end_date')"
              style="margin-left: 10px;"
              >End Date</p-radio
            >
          </div>
          <div class="row" style="padding: 15px">
            <datepicker
              placeholder="Select Date:"
              v-if="showPaymentDetailEndDate == true"
              v-model="paymentDetailEnd"
              name="paymentDetailEnd"
              input-class="calendar-input-custom"
              format="M/d/yy"
            ></datepicker>
          </div>
        </div>
        <br />

        <div style="text-align: center">
          <div style="margin-left: auto; margin-right: auto">
            <p-button
              round
              type="success"
              text
              @click="submitPaymentDetails"
              style="margin: 10px"
              >SAVE</p-button
            >
            <p-button
              round
              text
              @click="createPaymentDetailModal = false"
              style="margin: 10px"
              >Cancel</p-button
            >
          </div>
        </div>
      </modal>
      <!-- EDIT PAYMENT DETAIL MODAL  -->
      <modal
        :show.sync="editPaymentDetailModal"
        :show-close="false"
        :show-header="false"
        type="mini"
        class="modal-custom"
      >
        <h4 class="headline" style="padding-top: 0px; margin-top: 0px">
          Add Payment Detail
        </h4>

        <div class="form-group">
          <fg-input label="Amount:" v-model="paymentDetailAmount"></fg-input>
          <div style="margin-top: 10px;padding: 5px;">Payment Type:</div>
          <div
            class="row"
            style="padding-left: 10px; margin: 0px; padding: 0px"
          >
            <p-radio v-model="paymentDetailFrequency" label="monthly"
              >Monthly</p-radio
            >
            <p-radio
              v-model="paymentDetailFrequency"
              label="single"
              style="margin-left: 10px;"
              >Single</p-radio
            >
          </div>

          <div style="margin-top: 10px;padding: 5px;">
            <span>Start Date:</span>
          </div>
          <datepicker
            v-model="paymentDetailStart"
            placeholder="Select Date:"
            name="discountStart"
            input-class="calendar-input-custom"
            format="M/d/yy"
          ></datepicker>

          <div style="margin-top: 10px;padding: 5px;">
            <span>End Date:</span>
          </div>
          <div
            class="row"
            style="padding-left: 10px; margin: 0px; padding: 0px"
          >
            <p-radio
              v-model="paymentDetailEndType"
              label="ongoing"
              @input="setPaymentDetailEnd('ongoing')"
              >Ongoing</p-radio
            >
            <p-radio
              v-model="paymentDetailEndType"
              label="end_date"
              @input="setPaymentDetailEnd('end_date')"
              style="margin-left: 10px;"
              >End Date</p-radio
            >
          </div>
          <div class="row" style="padding: 15px">
            <datepicker
              placeholder="Select Date:"
              v-if="showPaymentDetailEndDate == true"
              v-model="paymentDetailEnd"
              name="paymentDetailEnd"
              input-class="calendar-input-custom"
              format="M/d/yy"
            ></datepicker>
          </div>
        </div>
        <br />

        <div style="text-align: center">
          <div style="margin-left: auto; margin-right: auto">
            <p-button
              round
              type="success"
              text
              @click="submitPaymentDetailsEdit"
              style="margin: 10px"
              >SAVE</p-button
            >
            <p-button
              round
              text
              @click="editPaymentDetailModal = false"
              style="margin: 10px"
              >Cancel</p-button
            >
          </div>
        </div>
      </modal>

      <!-- NEW COMMISSION DETAIL MODAL  -->
      <modal
        :show.sync="createCommissionDetailModal"
        :show-close="false"
        :show-header="false"
        type="mini"
        class="modal-custom"
      >
        <h4 class="headline" style="padding-top: 0px; margin-top: 0px">
          Add Commision
        </h4>
        <div v-if="commissionDetailModalError" class="error-note">
          {{ commissionDetailModalErrorMsg }}
        </div>

        <div class="form-group">
          <fg-input label="Amount:" v-model="commissionDetailAmount"></fg-input>
          <div style="margin-top: 10px;padding: 5px;">Payment Type:</div>
          <div
            class="row"
            style="padding-left: 10px; margin: 0px; padding: 0px"
          >
            <p-radio v-model="commissionDetailType" label="percentage"
              >Percent</p-radio
            >
            <p-radio
              v-model="commissionDetailType"
              label="fixed"
              style="margin-left: 10px;"
              >Dollars</p-radio
            >
          </div>

          <div style="margin-top: 10px;padding: 5px;">
            <span>Start Date:</span>
          </div>
          <datepicker
            v-model="commissionDetailStart"
            placeholder="Select Date:"
            name="discountStart"
            input-class="calendar-input-custom"
            format="M/d/yy"
          ></datepicker>

          <div style="margin-top: 10px;padding: 5px;">
            <span>End Date:</span>
          </div>
          <div
            class="row"
            style="padding-left: 10px; margin: 0px; padding: 0px"
          >
            <p-radio
              v-model="commissionDetailEndType"
              label="ongoing"
              @input="setCommissionDetailEnd('ongoing')"
              >Ongoing</p-radio
            >
            <p-radio
              v-model="commissionDetailEndType"
              label="end_date"
              @input="setCommissionDetailEnd('end_date')"
              style="margin-left: 10px;"
              >End Date</p-radio
            >
          </div>
          <div class="row" style="padding: 15px">
            <datepicker
              placeholder="Select Date:"
              v-if="showCommissionDetailEndDate == true"
              v-model="commissionDetailEnd"
              name="paymentDetailEnd"
              input-class="calendar-input-custom"
              format="M/d/yy"
            ></datepicker>
          </div>
        </div>
        <br />

        <div style="text-align: center">
          <div style="margin-left: auto; margin-right: auto">
            <p-button
              round
              type="success"
              text
              @click="submitCommissionDetails"
              style="margin: 10px"
              >SAVE</p-button
            >
            <p-button
              round
              text
              @click="createCommissionDetailModal = false"
              style="margin: 10px"
              >Cancel</p-button
            >
          </div>
        </div>
      </modal>

      <!-- NEW COMMISSION DETAIL MODAL  -->
      <modal
        :show.sync="commissionDetailModalUpdate"
        :show-close="false"
        :show-header="false"
        type="mini"
        class="modal-custom"
      >
        <h4 class="headline" style="padding-top: 0px; margin-top: 0px">
          Add Commision
        </h4>

        <div v-if="commissionDetailModalError" class="error-note">
          {{ commissionDetailModalErrorMsg }}
        </div>

        <div class="form-group">
          <fg-input label="Amount:" v-model="commissionDetailAmount"></fg-input>
          <div style="margin-top: 10px;padding: 5px;">Payment Type:</div>
          <div
            class="row"
            style="padding-left: 10px; margin: 0px; padding: 0px"
          >
            <p-radio v-model="commissionDetailType" label="percentage"
              >Percent</p-radio
            >
            <p-radio
              v-model="commissionDetailType"
              label="fixed"
              style="margin-left: 10px;"
              >Dollars</p-radio
            >
          </div>

          <div style="margin-top: 10px;padding: 5px;">
            <span>Start Date:</span>
          </div>
          <datepicker
            v-model="commissionDetailStart"
            placeholder="Select Date:"
            name="discountStart"
            input-class="calendar-input-custom"
            format="M/d/yy"
          ></datepicker>

          <div style="margin-top: 10px;padding: 5px;">
            <span>End Date:</span>
          </div>
          <div
            class="row"
            style="padding-left: 10px; margin: 0px; padding: 0px"
          >
            <p-radio
              v-model="commissionDetailEndType"
              label="ongoing"
              @input="setCommissionDetailEnd('ongoing')"
              >Ongoing</p-radio
            >
            <p-radio
              v-model="commissionDetailEndType"
              label="end_date"
              @input="setCommissionDetailEnd('end_date')"
              style="margin-left: 10px;"
              >End Date</p-radio
            >
          </div>
          <div class="row" style="padding: 15px">
            <datepicker
              placeholder="Select Date:"
              v-if="showCommissionDetailEndDate == true"
              v-model="commissionDetailEnd"
              name="paymentDetailEnd"
              input-class="calendar-input-custom"
              format="M/d/yy"
            ></datepicker>
          </div>
        </div>
        <br />

        <div style="text-align: center">
          <div style="margin-left: auto; margin-right: auto">
            <p-button
              round
              type="success"
              text
              @click="submitCommissionDetailsUpdate"
              style="margin: 10px"
              >SAVE</p-button
            >
            <p-button
              round
              text
              @click="commissionDetailModalUpdate = false"
              style="margin: 10px"
              >Cancel</p-button
            >
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>
<script>
import firebase from "firebase";
import axios from "axios";
import VoerroTagsInput from "@voerro/vue-tagsinput";
import { mapGetters, mapActions } from "vuex";
import { Select, Option } from "element-ui";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import {
  TimeLine,
  TimeLineItem,
  Badge,
  Modal,
} from "src/components/UIComponents";

import {
  influencerCampaignCandidateReadApi,
  influencerCandidateNoteUpdateApi,
  influencerCandidateNoteCreateApi,
  influencerCandidateNoteArchiveApi,
  influencerCandidateUpdateStatusApi,
  influencerCandidatePaymentDetailsApi,
  influencerTagSearchApi,
  influencerUpdateApi,
  influencerTagAddApi,
  influencerTagUpdateApi,
  influencerEventUpdateApi,
  influencerCandidateEventsAddApi,
  userLoadApi,
  instagramPostApi,
  discountCodeCreateApi,
  discountCodeArchiveApi,
  influencerDiscountReadApi,
  clientStoreCheckApi,
  influencerCampaignReadApi,
  trackingLinkTemplateListApi,
  trackingLinkReadListApi,
  trackingLinkCreateApi,
  trackingLinkUpdateApi,
  trackingLinkTemplateUpdateApi,
  paymentActionCreateApi,
  paymentActionReadApi,
  paymentActionListApi,
  paymentActionUpdateApi,
  paymentDetailCreateApi,
  paymentDetailListApi,
  paymentDetailUpdateApi,
  commissionDetailReadApi,
  commissionDetailListApi,
  commissionDetailCreateApi,
  instagramProfileCacheApi,
} from "@/config/appSettings";
import Axios from "axios";
export default {
  components: {
    "tags-input": VoerroTagsInput,
    TimeLine,
    TimeLineItem,
    Badge,
    Modal,
    [Select.name]: Select,
    [Option.name]: Option,
    Datepicker,
  },
  data: () => ({
    profileImg: "",
    commissionDetailModalError: false,
    commissionDetailModalErrorMsg: null,
    commissionDetailModalUpdate: false,
    commissionDetailList: [],
    showCommissionDetailEndDate: false,
    commissionDetailStart: null,
    commissionDetailEnd: null,
    commissionDetailAmount: null,
    commissionDetailEndType: "ongoing",
    commissionDetailType: null,
    createCommissionDetailModal: false,
    commissionDetail: null,
    activePaymentDetail: null,
    editPaymentDetailModal: false,
    showPaymentDetailEndDate: false,
    createPaymentDetailModal: false,
    paymentDetailFrequency: null,
    paymentDetailStart: null,
    paymentDetailAmount: null,
    paymentDetailEndType: "ongoing",
    paymentDetailEnd: "ongoing",
    paymentDetailList: [],
    loadingOverlay: true,
    loadingOverlayText: null,
    refreshOverlay: false,
    addNoteModal: false,
    editNoteModal: false,
    newNoteText: null,
    editNoteText: null,
    editNoteId: null,
    noteType: null,
    editNoteType: null,
    visibilityType: null,
    editVisibilityType: null,
    archiveNoteConfirm: false,
    archiveCandidateModal: false,
    editInfluencerDetailsModal: false,
    archiveNoteId: null,
    lead: null,
    leadAds: [],
    leadImage: null,
    auth: null,
    candidateId: null,
    candidateData: null,
    noteTypeOptions: ["campaign", "global"],
    noteVisiblityOptions: ["team", "team and client"],
    noteFormAlert: false,
    noteAlertClass: false,
    alertType: null,
    displayAlert: false,
    alertMsg: null,
    noteFormAlertMsg: null,
    influencerFirstName: null,
    influencerLastName: null,
    influencerAddr1: null,
    influencerAddr2: null,
    influencerCity: null,
    influencerZip: null,
    influencerState: null,
    influencerCountry: null,
    influencerEmail: null,
    influencerPhone: null,
    tagList: [],
    postList: [],
    selectedTags: null,
    tagSearchActive: false,
    eventSelectOptions: null,
    eventNote: null,
    eventTextInput: null,
    eventSelectInput: null,
    eventModalLabel: null,
    eventConfirmModal: false,
    eventSelectModal: false,
    eventTextInputModal: null,
    eventFormAlert: false,
    newDiscountModal: false,
    editDiscountModal: false,
    activeEvent: null,
    noteList: null,
    eventList: null,
    profileData: null,
    isTeam: false,
    isClient: false,
    newNoteVisibilityType: null,
    newNoteType: null,
    newNoteText: null,
    discountUse: "gift",
    discountEndType: "ongoing",
    discountStart: null,
    discountEnd: "ongoing",
    discountCode: null,
    discountAmount: null,
    discountFormat: null,
    influencerDiscountList: null,
    showEndDate: false,
    storeExists: false,
    campaignDetails: null,
    trackingLinkList: null,
    trackingLinkTemplate: null,
    trackingLinkTemplateList: null,
    trackingLinkTemplateLoading: false,
    trackingLinkTokenList: [
      "[[instagram]]",
      "[[influencer]]",
      "[[campaign_name]]",
      "[[campaign]]",
    ],
    currentEditLink: null,
    newTrackingLinkModal: false,
    editTrackingLinkModal: false,
    addTrackingLinkAlert: null,
    addTrackingLinkModal: false,
    addTrackingLinkAlert: false,
    addTrackingLinkErrors: [],
    trackingLinkArchiveAlert: false,
    trackingLinkArchiveAlertErrorMsg: null,
    archiveTrackingLinkModalMsg: "Confirm Archive Link?",
    newLandingPage: null,
    newLinkName: null,
    newUtmCampaign: null,
    newUtmSource: "helloconvo",
    newUtmMedium: null,
    newUtmTerm: null,
    newUtmContent: null,
    editLandingPage: null,
    editLinkName: null,
    editUtmCampaign: null,
    editUtmSource: null,
    editUtmMedium: null,
    editUtmTerm: null,
    editUtmContent: null,
    discountArchiveAlert: false,
    discountArchiveAlertErrorMsg: null,
    discountArchiveMsg: null,
    archiveDiscountDetails: null,
    candidateCommission: null,
    candidateRate: null,
    candidateRateRequirements: null,
    candidateRateAmount: null,
    paymentActions: null,
    paymentActionList: null,
    activePaymentAction: null,
    modelValidations: {
      influencerEmail: {
        email: true,
      },
    },
    updatePaymentActionModal: false,
    paymentSocialType: ["instagram", "tiktok", "youtube", "ugc ad"],
    paymentPlacementType: ["reel", "story", "feed", "upload"],
    paymentContentType: ["video", "image", "any"],
    archivePaymentActionModal: false,
    editPaymentActionModal: false,
    createPaymentActionModal: false,

    textCheck: [
      (v) => {
        if (v !== null && typeof v !== "undefined") {
          return v.length > 2 || "Please enter more than 3 characters.";
        }
        return "Required";
      },
    ],
  }),
  computed: mapGetters(["profileStore", "relatedProfileStore"]),
  created() {
    this.profileData = this.profileStore;
  },
  name: "CandidateDetail",

  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      this.$validator.validateAll().then((isValid) => {
        //console.log("CHECKING IS VALID:", isValid);
        //console.log("CHECKING REGISTER FORM: ", this.registerForm);
        this.$emit("on-submit", this.registerForm, isValid);
      });
    },
    async profilePicLoadCache(instagramProfile) {
      let profileCacheUrl = `${instagramProfileCacheApi}/?usertoken=${this.auth}&instagram=${instagramProfile}`;
      let profileCacheResponse = await axios.get(profileCacheUrl);
      if (profileCacheResponse.data.success == true) {
        this.profileImg = profileCacheResponse.data.imgUrl;
      
      }
     
    },
    async submitCommissionDetailsUpdate() {
      try {
        this.commissionDetailModalErrorMsg = null;
        this.commissionDetailModalError = false;
        if (
          this.commissionDetailAmount == null ||
          typeof this.commissionDetailAmount == "undefined" ||
          isNaN(this.commissionDetailAmount)
        ) {
          console.log("MISSING AMOUNT", this.commissionDetailAmount);
          this.commissionDetailModalErrorMsg = "Enter valid amount";
          this.commissionDetailModalError = true;
          return;
        }
        if (
          this.commissionDetailType == null ||
          typeof this.commissionDetailType == "undefined"
        ) {
          this.commissionDetailModalErrorMsg = "Enter commission type";
          this.commissionDetailModalError = true;
          return;
        }
        if (
          this.commissionDetailStart == null ||
          typeof this.commissionDetailStart == "undefined"
        ) {
          this.commissionDetailModalErrorMsg = "Enter start date";
          this.commissionDetailModalError = true;
          return;
        }

        let commissionDetailUpdate = {};
        commissionDetailUpdate.detailId = this.activeCommissionDetail._id;
        commissionDetailUpdate.usertoken = this.auth;
        commissionDetailUpdate.amount = this.commissionDetailAmount;
        commissionDetailUpdate.type = this.commissionDetailType;
        commissionDetailUpdate.start = moment(
          this.commissionDetailStart
        ).format("YYYY-MM-DDTHH:mm:ssZ");
        if (this.commissionDetailEndType !== "ongoing") {
          commissionDetailUpdate.end = moment(this.commissionDetailEnd).format(
            "YYYY-MM-DDTHH:mm:ssZ"
          );
        }
        commissionDetailUpdate.influencer = this.candidateId;

        let uppdateCommissionDetailsResponse = await axios.post(
          commissionDetailUpdateApi,
          commissionDetailUpdate
        );

        /*console.log(
          "DISCOUNT RESPONSE:",
          uppdateCommissionDetailsResponse.data
        );*/
        if (uppdateCommissionDetailsResponse.data.success == true) {
          // CLOSE MODAL

          this.loadPaymentDetails();
          this.editCommissionDetailModal = false;
          return;
        }
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    async submitCommissionDetails() {
      try {
        this.commissionDetailModalErrorMsg = null;
        this.commissionDetailModalError = false;
        if (
          this.commissionDetailAmount == null ||
          typeof this.commissionDetailAmount == "undefined" ||
          isNaN(this.commissionDetailAmount)
        ) {
          console.log("MISSING AMOUNT", this.commissionDetailAmount);
          this.commissionDetailModalErrorMsg = "Enter valid amount";
          this.commissionDetailModalError = true;
          return;
        }
        if (
          this.commissionDetailType == null ||
          typeof this.commissionDetailType == "undefined"
        ) {
          this.commissionDetailModalErrorMsg = "Enter commission type";
          this.commissionDetailModalError = true;
          return;
        }
        if (
          this.commissionDetailStart == null ||
          typeof this.commissionDetailStart == "undefined"
        ) {
          this.commissionDetailModalErrorMsg = "Enter start date";
          this.commissionDetailModalError = true;
          return;
        }

        let newCommissionDetail = {};

        newCommissionDetail.usertoken = this.auth;

        newCommissionDetail.amount = this.commissionDetailAmount;
        newCommissionDetail.type = this.commissionDetailType;
        newCommissionDetail.start = moment(this.commissionDetailStart).format(
          "YYYY-MM-DDTHH:mm:ssZ"
        );
        if (this.commissionDetailEndType !== "ongoing") {
          newCommissionDetail.end = moment(this.commissionDetailEnd).format(
            "YYYY-MM-DDTHH:mm:ssZ"
          );
        }
        newCommissionDetail.influencer = this.candidateId;

        //console.log("NEW COMMISSION", newCommissionDetail);

        let createCommissionDetailsResponse = await axios.post(
          commissionDetailCreateApi,
          newCommissionDetail
        );

        /*console.log(
          "CREATE COMMISSION RESPONSE:",
          createCommissionDetailsResponse.data
        );*/

        if (createCommissionDetailsResponse.data.success == true) {
          // CLOSE MODAL

          this.loadCommissionDetails();
          this.createCommissionDetailModal = false;
          return;
        }
        // SET ERROR RESPONSE
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }

      //newDiscount.campaign =
      //newDiscount.influencer =
    },
    async setCommissionDetailEnd(event) {
      try {
        //console.log(event);

        if (event === "ongoing") {
          this.showCommissionDetailEndDate = false;
          this.paymentCommissionEndType = "ongoing";
          this.paymentCommissionEnd = "ongoing";
          return;
        }
        if (event === "end_date") {
          this.showCommissionDetailEndDate = true;
          this.paymentCommissionEnd = null;
          this.paymentCommissionEndType = "end_date";
          return;
        }
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    async showCommissionDetailCreateModal() {
      this.createCommissionDetailModal = true;
      this.commissionDetail = null;
      this.commissionDetailAmount = null;
      this.commissionDetailType = null;
      this.commissionDetailStart = null;
      this.commissionDetailEndType = "ongoing";
    },
    async loadCommissionDetails() {
      try {
        let commissionDetailResponse = await axios.get(
          `${commissionDetailListApi}/?usertoken=${this.auth}&influencer=${this.$route.params.candidateId}`
        );
        /*console.log(
          "LOADING COMMISSION DETAIL LIST",
          commissionDetailResponse.data.result
        );*/
        if (commissionDetailResponse.data.success == true) {
          /*console.log(
            "LOADING COMMISSSION DETAIL LIST",
            commissionDetailResponse.data.result
          );*/
          if (commissionDetailResponse.data.result.length > 0) {
            this.commissionDetailList = commissionDetailResponse.data.result;
            return;
          }
        }
        this.commissionDetailList = [];
      } catch (err) {
        //console.log("THERE WAS AN ERROR:", err);
      }
    },
    async submitPaymentDetailsEdit() {
      try {
        let updatePaymentDetail = {};
        updatePaymentDetail.detailId = this.activePaymentDetail._id;
        updatePaymentDetail.usertoken = this.auth;
        updatePaymentDetail.amount = this.paymentDetailAmount;
        updatePaymentDetail.frequency = this.paymentDetailFrequency;
        updatePaymentDetail.start = moment(this.paymentDetailStart).format(
          "YYYY-MM-DDTHH:mm:ssZ"
        );
        if (this.paymentDetailEndType !== "ongoing") {
          updatePaymentDetail.end = moment(this.paymentDetailEnd).format(
            "YYYY-MM-DDTHH:mm:ssZ"
          );
        }
        updatePaymentDetail.influencer = this.candidateId;

        let createPaymentDetailsResponse = await axios.post(
          paymentDetailUpdateApi,
          updatePaymentDetail
        );

        //console.log("DISCOUNT RESPONSE:", createPaymentDetailsResponse.data);
        if (createPaymentDetailsResponse.data.success == true) {
          // CLOSE MODAL

          this.loadPaymentDetails();
          this.editPaymentDetailModal = false;
          return;
        }
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    async showPaymentDetailEditModal(detailId) {
      try {
        this.activePaymentDetail = null;
        this.editPaymentDetailModal = true;
        let activeDetail = this.paymentDetailList.filter((x) => {
          return x._id == detailId;
        })[0];
        this.activePaymentDetail = activeDetail;
        //console.log("ACTIVE DETAIL:", activeDetail);
        this.paymentDetailAmount = activeDetail.amount;
        this.paymentDetailFrequency = activeDetail.frequency;
        this.paymentDetailStart = activeDetail.startDate;
        if (typeof activeDetail.endDate !== "undefined") {
          this.paymentDetailEnd = activeDetail.endDate;
        }
      } catch (err) {}
    },
    async loadPaymentDetails() {
      try {
        this.paymentDetailList = []
        let paymentDetailResponse = await axios.get(
          `${paymentDetailListApi}/?usertoken=${this.auth}&influencer=${this.$route.params.candidateId}`
        );
        //console.log("LOADING PAYMENT DETAIL LIST", paymentDetailResponse.data);
        if (paymentDetailResponse.data.success == true) {
          /*console.log(
            "LOADING PAYMENT DETAIL LIST",
            paymentDetailResponse.data.result
          );*/
          if (paymentDetailResponse.data.result.length > 0) {
            this.paymentDetailList = paymentDetailResponse.data.result;
            return;
          }
        }
        this.paymentDetailList = [];
      } catch (err) {
        //console.log("THERE WAS AN ERROR:", err);
      }
    },
    async submitPaymentDetails() {
      try {
        let newPaymentDetail = {};
        newPaymentDetail.usertoken = this.auth;
        newPaymentDetail.amount = this.paymentDetailAmount;
        newPaymentDetail.frequency = this.paymentDetailFrequency;
        newPaymentDetail.start = moment(this.paymentDetailStart).format(
          "YYYY-MM-DDTHH:mm:ssZ"
        );
        if (this.paymentDetailEndType !== "ongoing") {
          newPaymentDetail.end = moment(this.paymentDetailEnd).format(
            "YYYY-MM-DDTHH:mm:ssZ"
          );
        }
        newPaymentDetail.influencer = this.candidateId;

        let createPaymentDetailsResponse = await axios.post(
          paymentDetailCreateApi,
          newPaymentDetail
        );

        if (createPaymentDetailsResponse.data.success == true) {
          // CLOSE MODAL

          this.loadPaymentDetails();
          this.createPaymentDetailModal = false;
          return;
        }
        // SET ERROR RESPONSE
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }

      //newDiscount.campaign =
      //newDiscount.influencer =
    },
    async setPaymentDetailEnd(event) {
      try {
        //console.log(event);

        if (event === "ongoing") {
          this.showPaymentDetailEndDate = false;
          this.paymentDetailEndType = "ongoing";
          this.paymentDetailEnd = "ongoing";
          return;
        }
        if (event === "end_date") {
          this.showPaymentDetailEndDate = true;
          this.paymentDetailEnd = null;
          this.paymentDetailEndType = "end_date";
          return;
        }
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    async showPaymentDetailCreateModal() {
      this.createPaymentDetailModal = true;
      this.activePaymentDetail = null;
      this.paymentDetailAmount = null;
      this.paymentDetailFrequency = null;
      this.paymentDetailStart = null;
      this.paymentDetailEdit = "ongoing";
    },

    async updatePaymentAction() {
      if (this.paymentActions !== null) {
        //console.log("RAW DATA:", this.paymentActions);
        let updatePaymentActionDetails = {};
        updatePaymentActionDetails.contentType = this.paymentActions.contentType;
        updatePaymentActionDetails.platform = this.paymentActions.platform;
        updatePaymentActionDetails.placement = this.paymentActions.placement;
        updatePaymentActionDetails.count = this.paymentActions.count;
        updatePaymentActionDetails.actionId = this.activePaymentAction._id;
        updatePaymentActionDetails.usertoken = this.auth;
        //console.log("UPDATE PAYMENT ACTION:", updatePaymentAction);
        let newPaymentActionResponse = await axios.post(
          paymentActionUpdateApi,
          updatePaymentActionDetails
        );
        //console.log("RESPONSE:", newPaymentActionResponse.data);
        if (newPaymentActionResponse.data.success == true) {
          this.updatePaymentActionModal = false;
          await this.loadPaymentActions();
        }
      }
      return;
    },
    async updateCandidateComission() {
      /*
      
      TYPES
      1. Percent 
      2. Fixed 

      AMOUNT       
      */
    },
    async showUpdatePaymentActionModal(actionId) {
      try {
        this.paymentActions = {};
        await this.setActivePaymentAction(actionId);
        this.paymentActions.contentType = this.activePaymentAction.contentType;
        this.paymentActions.platform = this.activePaymentAction.platform;
        this.paymentActions.placement = this.activePaymentAction.placement;
        this.paymentActions.count = this.activePaymentAction.count;
        this.paymentActions.actionId = this.activePaymentAction._id;
        // SET VARIABLES
        this.updatePaymentActionModal = true;
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    async setActivePaymentAction(actionId) {
      try {
        this.activePaymentAction = this.paymentActionList.filter((x) => {
          return x._id == actionId;
        })[0];
        //console.log("ACTIVE ACTION:", this.activePaymentAction);
      } catch (err) {}
    },
    async showArchivePaymentModal(actionId) {
      this.activePaymentAction = null;
      await this.setActivePaymentAction(actionId);
      this.archivePaymentActionModal = true;
    },
    async submitArchivePaymentAction() {
      //console.log("DELETING:", this.activePaymentAction._id)
      let archivePaymentAction = {};
      archivePaymentAction.actionId = this.activePaymentAction._id;
      archivePaymentAction.usertoken = this.auth;
      archivePaymentAction.status = "archived";

      let archiveActionResponse = await axios.post(
        paymentActionUpdateApi,
        archivePaymentAction
      );
      //console.log("ARCHIVE RESPONSE: ", archiveActionResponse.data)
      this.archivePaymentActionModal = false;
      await this.loadPaymentActions();
    },
    async showEditPaymentModal(actionId) {
      this.activePaymentAction = null;
      await this.setActivePaymentAction(actionId);
      this.archivePaymentActionModal = true;
    },
    async updateCandidateRate() {},
    async showCreatePaymentModal() {
      this.activePaymentAction = null;
      this.paymentActions = {};

      this.createPaymentActionModal = true;
    },
    async createPaymentAction() {
      if (this.paymentActions !== null) {
        console.log("RAW DATA:", this.paymentActions);
        let newPaymentAction = {};
        newPaymentAction.contentType = this.paymentActions.contentType;
        newPaymentAction.platform = this.paymentActions.platform;
        newPaymentAction.placement = this.paymentActions.placement;
        newPaymentAction.count = this.paymentActions.count;
        newPaymentAction.influencerId = this.candidateId;
        newPaymentAction.usertoken = this.auth;
        console.log("NEW PAYMENT ACTION:", newPaymentAction);
        let newPaymentActionResponse = await axios.post(
          paymentActionCreateApi,
          newPaymentAction
        );
        console.log("RESPONSE:", newPaymentActionResponse.data);
        if (newPaymentActionResponse.data.success == true) {
          this.createPaymentActionModal = false;
          await this.loadPaymentActions();
        }
      }
      return;
    },
    async loadPosts() {
      try {
        let instagramPostResponse = await axios.get(
          `${instagramPostApi}/?usertoken=${this.auth}&instagram=${this.candidateData.instagramProfile}`
        );

        //console.log("POST LIST :", instagramPostResponse.data);

        if (instagramPostResponse.data.success === true) {
          //console.log("SETTING POST LIST:");

          this.postList = instagramPostResponse.data.result.slice(0, 4);
          //this.filterList("feed");
          //console.log("POST LIST SET:", this.postList);
        }
      } catch (err) {
        ///console.log("THERE WAS AN ERROR:", err);
      }
    },
    async loadCandidate() {
      try {
        this.loadingOverlay = true;
        let candiateDetailUrl = `${influencerCampaignCandidateReadApi}/?candidate=${this.$route.params.candidateId}&usertoken=${this.auth}`;

        let candidateDetail = await axios.get(candiateDetailUrl);
       
        if (candidateDetail.data.success === true) {
          this.candidateData = candidateDetail.data.result;
          this.profileImg = this.candidateData.fullProfile.profilePic;
          if (
            typeof this.candidateData.fullProfile.profilePicCache !==
            "undefined"
          ) {
            this.profileImg = this.candidateData.fullProfile.profilePicCache;
          }
       
          this.loadingOverlay = false;
          if (this.candidateData.events.length > 0) {
            this.eventList = this.candidateData.events;
          }
          if (this.candidateData.events.length < 1) {
            let candidateEventResponse = await axios.post(
              influencerCandidateEventsAddApi,
              {
                usertoken: this.auth,
                candidate: this.$route.params.candidateId,
              }
            );
            /*console.log(
              "HERE ARE THE CANDIDATE EVENT RESPONSE:",
              candidateEventResponse
            );*/
            this.eventList = candidateEventResponse.data.result;
          }

          this.noteList = this.candidateData.notes;
          if (this.isClient) {
            this.noteList = this.candidateData.notes.filter((x) => {
              return (x.visibility = "all");
            });
            this.noteList = this.candidateData.notes.filter((x) => {
              return (x.type = "campaign");
            });
          }

          // SET EMAIL
          if (
            typeof this.candidateData.influencerDetails.email !== "undefined"
          ) {
            this.influencerEmail = this.candidateData.influencerDetails.email;
          } else if (
            typeof this.candidateData.fullProfile.email !== "undefined"
          ) {
            this.influencerEmail = this.candidateData.fullProfile.email;
          }
          // SET CANDIDATE FORM DETAILS
          if (
            typeof this.candidateData.influencerDetails.instagramId !==
            "undefined"
          ) {
            this.influencerFirstName = this.candidateData.influencerDetails.firstName;
            this.influencerLastName = this.candidateData.influencerDetails.lastName;
            this.influencerAddr1 = this.candidateData.influencerDetails.address1;
            this.influencerAddr2 = this.candidateData.influencerDetails.address2;
            this.influencerState = this.candidateData.influencerDetails.addressState;
            this.influencerCountry = this.candidateData.influencerDetails.addressCountry;
            this.influencerZip = this.candidateData.influencerDetails.addressZipcode;
            this.influencerCity = this.candidateData.influencerDetails.addressCity;
            try {
              this.selectedTags = this.candidateData.influencerDetails.tags.map(
                (x) => {
                  return { key: x, value: x };
                }
              );
            } catch (err) {
              //console.log("NO TAGS FOUND", err);
            }
          }
        }
      } catch (err) {}
    },
    async showNoteModal() {
      try {
        this.noteFormAlert = false;
        this.addNoteModal = true;
        this.newNoteText = null;
        this.newNoteType = null;
        this.newNoteVisibilityType = null;
      } catch (err) {}
    },
    async closeNoteModal() {
      try {
        this.addNoteModal = false;
        this.noteType = null;
        this.visibilityType = null;
        this.newNoteText = null;
        this.noteFormAlertMsg = "";
        this.noteFormAlert = false;
      } catch (err) {}
    },
    async showEditNoteModal(noteData) {
      try {
        //console.log(noteData);
        this.noteEditFormAlert = false;
        this.editNoteModal = true;
        this.editNoteText = noteData.text;
        this.editNoteType = noteData.type;
        this.editNoteId = noteData._id;
        this.editVisibilityType = noteData.visibility;
        if (noteData.visibility === "all") {
          this.editVisibilityType = "team and client";
        }
      } catch (err) {}
    },
    async closeEditNoteModal() {
      try {
        this.editNoteModal = false;
        this.editNoteFormAlertMsg = "";
        this.editNoteFormAlert = false;
        this.editNoteText = noteData.text;
        this.editNoteType = noteData.type;
        this.editNoteId = noteData._id;
        this.editVisibilityType = noteData.visibility;
      } catch (err) {}
    },
    async showArchiveNoteConfirm(noteId) {
      try {
        //console.log(noteId);
        this.archiveNoteConfirm = true;
        this.archiveNoteId = noteId;
      } catch (err) {}
    },
    async closeArchiveNoteConfirm() {
      try {
        this.archiveNoteConfirm = false;
        this.archiveNoteId = null;
      } catch (err) {}
    },
    async showArchiveCandidateModal() {
      try {
        this.archiveCandidateModal = true;
      } catch (err) {}
    },
    async closeArchiveCandidateModal() {
      try {
        this.archiveCandidateModal = false;
      } catch (err) {}
    },
    async submitNote(e) {
      e.preventDefault();

      try {
        let self = this;

        if (this.isClient === true) {
          this.newNoteVisibilityType = "all";
          this.newNoteType = "campaign";
        }
        let noteErrors = [];
        if (this.newNoteText == null || this.newNoteText.trim() == "") {
          noteErrors.push("Missing note text.");
        }
        if (this.newNoteType == null || this.newNoteType.trim() == "") {
          noteErrors.push("Note type required.");
        }
        if (typeof this.newNoteVisibilityType == "undefined") {
          noteErrors.push("Note visibility undefined.");
        } else {
          //console.log("VISIBILITY CHECK:", this.newNoteVisibilityType);
          if (
            this.newNoteVisibilityType == null ||
            this.newNotevisibilityType == ""
          ) {
            noteErrors.push("Visibility type required.");
          }
        }

        if (noteErrors.length < 1) {
          this.noteFormAlert = true;
          let newNote = {};
          newNote.text = this.newNoteText;
          newNote.visibility = this.newNoteVisibilityType;
          if (this.newNoteVisibilityType === "team and client") {
            newNote.visibility = "all";
          }

          newNote.type = this.newNoteType;
          newNote.usertoken = this.auth;
          newNote.candidate = this.$route.params.candidateId;
          //console.log("HERE IS THE NEW NOTE:", newNote);

          // SUBMIT NOTE
          let newNoteResponse = await axios.post(
            influencerCandidateNoteCreateApi,
            newNote
          );
          //console.log("HERES THE RESPONSE:", newNoteResponse.data);
          if (newNoteResponse.data.success === true) {
            //console.log("NEW NOTE CREATED");
            this.addNoteModal = false;
            this.loadingOverlayText = "Saving Note...";
            this.loadCandidate();
            window.scrollTo(0, document.body.scrollHeight);
            return;
          }

          //console.log("NOTE FAILED");
          self.alertType = "error";
          self.noteFormAlertMsg = "Note creation failed.";
          self.noteFormAlert = true;

          // IF FAILED KEEP OPEN
        } else {
          //console.log("VALIDATE FAILED");
          self.alertType = "error";
          self.noteAlertClass = "error-note";
          self.noteFormAlertMsg = noteErrors[0];
          self.noteFormAlert = true;
        }
      } catch (err) {
        //console.log("THERE WAS AN ERROR", err);

        self.alertType = "error";
        self.noteAlertClass = "error-note";
        self.noteFormAlertMsg = "Please check all fields.";
        self.noteFormAlert = true;
      }
    },
    async submitEditNote(e) {
      e.preventDefault();

      try {
        let self = this;
        let editNoteErrors = [];

        //console.log("NOTE TEXT:", this.editNoteText);
        //console.log("NOTE TYPE:", this.editNoteType);
        //console.log("NOTE VISIBILITY:", this.editVisibilityType);
        if (this.editNoteText == null || this.editNoteText.trim() == "") {
          editNoteErrors.push("Missing note text.");
        }
        if (this.editNoteType == null || this.editNoteType.trim() == "") {
          editNoteErrors.push("Note type required.");
        }
        if (typeof this.editVisibilityType == "undefined") {
          editNoteErrors.push("Note visibility undefined.");
        } else {
          //console.log("VISIBILITY CHECK:", this.editVisibilityType);
          if (
            this.editVisibilityType == null ||
            this.editVisibilityType == ""
          ) {
            editNoteErrors.push("Visibility type required.");
          }
        }
        if (editNoteErrors.length < 1) {
          let updateNote = {};
          updateNote.text = this.editNoteText;
          updateNote.visibility = this.editVisibilityType;
          if (this.editVisibilityType === "team and client") {
            updateNote.visibility = "all";
          }
          updateNote.id = this.editNoteId;
          updateNote.type = this.editNoteType;
          updateNote.usertoken = this.auth;
          //console.log("HERE IS THE NEW NOTE:", updateNote);

          // SUBMIT NOTE
          let updateNoteResponse = await axios.post(
            influencerCandidateNoteUpdateApi,
            updateNote
          );
          //console.log("HERES THE RESPONSE:", updateNoteResponse.data);
          if (updateNoteResponse.data.success === true) {
            //console.log("NEW NOTE CREATED");
            this.closeEditNoteModal();
            this.loadingOverlayText = "Saving Note...";
            this.loadCandidate();
            window.scrollTo(0, document.body.scrollHeight);
            return;
          }

          //console.log("NOTE FAILED");
          self.alertType = "error";
          self.noteFormAlertMsg = "Note creation failed.";
          self.noteFormAlert = true;

          // IF FAILED KEEP OPEN
        } else {
          //console.log("VALIDATE FAILED");
          self.alertType = "error";
          self.noteFormAlertMsg = "Please check all fields.";

          self.editNoteFormAlert = true;
        }
      } catch (err) {
        //console.log("THERE WAS AN ERROR", err);

        self.alertType = "error";
        self.noteFormAlertMsg = "Please check all fields.";
        self.noteFormAlert = true;
      }
    },
    async submitArchiveNote() {
      try {
        let archiveNote = {};
        archiveNote.id = this.archiveNoteId;
        archiveNote.usertoken = this.auth;
        //console.log("HERE IS THE NEW NOTE:", archiveNote);

        this.archiveNoteConfirm = false;
        this.loadingOverlayText = "Archiving Note...";

        // SUBMIT NOTE
        let archiveNoteResponse = await axios.post(
          influencerCandidateNoteArchiveApi,
          archiveNote
        );
        //console.log("HERES THE RESPONSE:", archiveNoteResponse.data);
        if (archiveNoteResponse.data.success === true) {
          this.archiveNoteId = null;
          this.loadCandidate();
          window.scrollTo(0, document.body.scrollHeight);
          return;
        }
        //console.log("NOTE FAILED");
        self.alertType = "error";
        self.alertMsg = "Note archive failed.";
        self.displayAlert = true;
        window.scrollTo(0, 0);

        // IF FAILED KEEP OPEN
      } catch (err) {
        //console.log("THERE WAS AN ERROR", err);
        self.alertType = "error";
        self.alertMsg = "Could not archive note.";
        self.displayAlert = true;
        window.scrollTo(0, 0);
      }
    },
    async submitArchiveCandidate() {
      try {
        let archiveCandidate = {};
        archiveCandidate.candidate = this.candidateId;
        archiveCandidate.usertoken = this.auth;
        archiveCandidate.status = "archived";

        this.archiveCandidateModal = false;
        this.loadingOverlayText = "Deleting Candidate...";

        // SUBMIT NOTE
        let archiveCandidateResponse = await axios.post(
          influencerCandidateUpdateStatusApi,
          archiveCandidate
        );
        //console.log("HERES THE RESPONSE:", archiveCandidateResponse.data);
        if (archiveCandidateResponse.data.success === true) {
          this.$router.push(
            `/influencer-campaign/list/${this.candidateData.campaign.campaignId}`
          );
        }
        //console.log("CANDIDATE  FAILED");
        self.alertType = "error";
        self.alertMsg = "Could not archive candidate.";
        self.displayAlert = true;
        window.scrollTo(0, 0);

        // IF FAILED KEEP OPEN
      } catch (err) {
        //console.log("THERE WAS AN ERROR", err);
        self.alertType = "error";
        self.alertMsg = "Could not archive Candidate.";
        self.displayAlert = true;
        window.scrollTo(0, 0);
      }
    },
    async submitInfluencerDetails() {
      //console.log("INFLUENER EMAIL: ", this.influencerEmail);
      if (this.influencerEmail !== null && this.influencerEmail.trim() !== "") {
        let validEmail = await this.$validator.validateAll();
        if (validEmail == false) {
          //console.log("PLEASE ENTER A VALID EMAIL");
          return;
        }
      }
      let influencerUpdate = {};
      influencerUpdate.usertoken = this.auth;
      influencerUpdate.firstName = this.influencerFirstName;
      influencerUpdate.lastName = this.influencerLastName;
      influencerUpdate.city = this.influencerCity;
      influencerUpdate.zip = this.influencerZip;
      influencerUpdate.state = this.influencerState;
      influencerUpdate.country = this.influencerCountry;
      influencerUpdate.address1 = this.influencerAddr1;
      influencerUpdate.address2 = this.influencerAddr2;
      influencerUpdate.email = this.influencerEmail;
      influencerUpdate.phone = this.influencerPhone;
      influencerUpdate.instagramId = this.candidateData.instagramId;

      let influencerUpdateResponse = await axios.post(
        influencerUpdateApi,
        influencerUpdate
      );
      //console.log("UPDATE INFLUENCER RESPONSE:", influencerUpdateResponse);
      if (influencerUpdateResponse.data.success === true) {
        this.editInfluencerDetailsModal = false;
        this.loadCandidate();
      }
    },
    async showNewDiscountModal() {
      this.newDiscountModal = true;
      this.discountCode = null;
      this.discountUse = null;
      this.discountAmount = null;
      this.discountFormat = null;
      this.discountStart = null;
      this.discountEnd = "ongoing";
      //newDiscount.campaign =
      //newDiscount.influencer =

      //console.log("NEW DISCOUNT DATA:", newDiscount);
    },
    async submitDiscountCode() {
      try {
        let newDiscount = {};

        newDiscount.code = this.discountCode;
        newDiscount.type = this.discountUse;
        newDiscount.amount = -Math.abs(this.discountAmount);

        newDiscount.format = this.discountFormat;
        newDiscount.start = moment(this.discountStart).format(
          "YYYY-MM-DDTHH:mm:ssZ"
        );
        if (this.discountEnd !== "ongoing") {
          newDiscount.end = moment(this.discountEnd).format(
            "YYYY-MM-DDTHH:mm:ssZ"
          );
        }
        newDiscount.influencer = this.candidateId;
        newDiscount.campaign = this.candidateData.campaignId;
        //console.log("NEW DISCOUNT DATA:", newDiscount);

        let createDiscountResponse = await axios.post(
          discountCodeCreateApi,
          newDiscount
        );

        //console.log("DISCOUNT RESPONSE:", createDiscountResponse.data);
        if (createDiscountResponse.data.success == true) {
          // CLOSE MODAL
          this.influencerDiscountList = null;
          this.loadInfluencerDiscounts();
          this.newDiscountModal = false;
          return;
        }
        // SET ERROR RESPONSE
        //console.log("SETTING ERROR RESPONSE...");
      } catch (err) {
        //console.log("THERE WAS AN ERROR:", err);
      }

      //newDiscount.campaign =
      //newDiscount.influencer =
    },
    async setDiscountEnd(event) {
      try {
        //console.log(event);

        if (event === "ongoing") {
          this.showEndDate = false;
          this.discountEndType = "ongoing";
          this.discountEnd = "ongoing";
          return;
        }
        if (event === "end_date") {
          this.showEndDate = true;
          this.discountEnd = null;
          this.discountEndType = "end_date";
          return;
        }
      } catch (err) {
        //console.log("THERE WAS AN ERROR:", err);
      }
    },
    async tagSearch(value) {
      if (this.tagSearchActive === false) {
        if (value.length > 3) {
          this.tagSearchActive = true;
          //console.log("HERE IS THE TAG:", value);

          let tagSearchResponse = await axios.get(
            `${influencerTagSearchApi}/?usertoken=${this.auth}&tag=${value}`
          );
          //console.log("HERE IS THE SEARCH RESULT:", tagSearchResponse.data);
          this.tagSearchActive = false;
          if (tagSearchResponse.data.success === true) {
            let tagList = tagSearchResponse.data.result.map((x) => {
              return { value: x.name, key: x.name };
            });
            this.tagList = tagList;
          }
        }
      }
    },
    async tagAdd(tag) {
      //console.log("HELLO WORLD ADDED TAG");
      //console.log("VALUE ADDED:", tag);
      //console.log("CHECK TAG RESULT:", this.candidateData.influencerDetails.tags.indexOf(tag.value) )
      //console.log("CHECKING TAGS: ", this.candidateData.influencerDetails.tags);
      if (typeof this.candidateData.influencerDetails.tags === "undefined") {
        let newTag = {};
        newTag.tag = tag.value;
        newTag.usertoken = this.auth;
        newTag.instagramId = this.candidateData.instagramId;
        //console.log("SENDING THIS TAG:", newTag);
        let tagAddResponse = await axios.post(influencerTagAddApi, newTag);

        return;
      }
      if (this.candidateData.influencerDetails.tags.indexOf(tag.value) === -1) {
        let newTag = {};
        newTag.tag = tag.value;
        newTag.usertoken = this.auth;
        newTag.instagramId = this.candidateData.instagramId;
        //console.log("SENDING THIS TAG:", newTag);
        let tagAddResponse = await axios.post(influencerTagAddApi, newTag);
        // console.log("HERE IS THE ADD RESULT:", tagAddResponse.data);
        return;
      }
    },
    async tagRemove() {
      //console.log("HELLO WORLD REMOVED TAG");

      let tagUpdate = this.selectedTags.map((x) => {
        return x.value.toLowerCase();
      });
      let newTag = {};
      newTag.tags = tagUpdate;
      newTag.usertoken = this.auth;
      newTag.instagramId = this.candidateData.instagramId;

      // console.log("LATEST TAGS:", tagUpdate);
      let tagUpdateResponse = await axios.post(influencerTagUpdateApi, newTag);
      //console.log("HERE IS THE SEARCH RESULT:", tagAddResponse.data
    },
    async showEventConfirmModal(event) {
      //console.log("GOT EVENT:", event);
      this.activeEvent = event;
      this.eventModalLabel = event.eventData.inputLabel;
      this.eventConfirmModal = true;
    },
    async showEventSelectModal(event) {
      try {
        //console.log("GOT EVENT:", event);
        this.activeEvent = event;
        this.eventSelectOptions = event.eventData.options;
        this.eventModalLabel = event.eventData.inputLabel;
        this.eventSelectModal = true;
      } catch (err) {
        //console.log("THERE WAS AN ERROR:", err);
      }
    },
    async closeEventSelectModal() {
      this.activeEvent = null;
      this.eventSelectOptions = null;
      this.eventModalLabel = null;
      this.eventSelectModal = false;
    },
    async closeEventConfirmModal() {
      this.activeEvent = null;
      this.eventSelectOptions = null;
      this.eventModalLabel = null;
      this.eventConfirmModal = false;
    },
    async showEventInputModal() {},
    async closeEventInputModal() {
      this.activeEvent = null;
    },
    async setPaymentRequirements() {
      let newPaymentActions = {};
    },
    async loadPaymentActions() {
      let paymentActionListUrl = `${paymentActionListApi}/?usertoken=${this.auth}&influencer=${this.candidateId}`;
      let paymentActionListResponse = await axios.get(paymentActionListUrl);
      if (paymentActionListResponse.data.success == true) {
        this.paymentActionList = paymentActionListResponse.data.result;
      }
    },

    async loadInfluencerDiscounts() {
      try {
        let influencerDiscountResponse = await axios.get(
          `${influencerDiscountReadApi}/${this.$route.params.candidateId}`
        );

        if (influencerDiscountResponse.data.success == true) {
          if (influencerDiscountResponse.data.result.length > 0) {
            this.influencerDiscountList =
              influencerDiscountResponse.data.result;
            return;
          }
        }
        this.influencerDiscountList = [];
      } catch (err) {
        //console.log("THERE WAS AN ERROR:", err);
      }
    },
    async clientStoreCheck() {
      try {
        let clientStoreCheckResponse = await axios.get(
          `${clientStoreCheckApi}/?usertoken=${this.auth}&client=${this.campaignDetails.clientId}`
        );

        if (clientStoreCheckResponse.data.success == true) {
          console.log("CLIENT STORE RESULTS:", clientStoreCheckResponse.data);
          this.storeExists = true;
        }
      } catch (err) {
        //console.log("THERE WAS AN ERROR:", err);
      }
    },
    async showAddTrackingLinkModal() {
      this.trackingLinkTemplate = null;
      this.loadTrackingLinkTemplates();
      this.newTrackingLinkModal = true;
      this.newLandingPage = null;
      this.newLinkName = null;
      this.newUtmCampaign = null;
      this.newUtmSource = null;
      this.newUtmMedium = null;
      this.newUtmTerm = null;
      this.newUtmContent = null;
    },
    async showTrackingLinkEditModal(linkId) {
      this.editTrackingLinkModal = true;
      this.editTrackingLinkAlertMsg = null;
      this.editTrackingLinkAlertType = null;
      this.editTrackingLinkAlert = false;

      this.currentEditLink = this.trackingLinkList.filter((x) => {
        return x._id == linkId;
      });
      //console.log("EDIT LINK DATA:", this.currentEditLink);
      if (this.currentEditLink.length > 0) {
        this.editLandingPage = this.currentEditLink[0].landingPage;
        this.editLinkName = this.currentEditLink[0].name;
        this.editUtmCampaign = this.currentEditLink[0].utmCampaign;
        this.editUtmSource = this.currentEditLink[0].utmSource;
        this.editUtmMedium = this.currentEditLink[0].utmMedium;
        this.editUtmTerm = this.currentEditLink[0].utmTerm;
        this.editUtmContent = this.currentEditLink[0].utmContent;
      }
    },
    async showArchiveTrackingLinkAlert(linkId) {
      this.currentEditLink = null;
      this.trackingLinkArchiveAlert = true;
      this.trackingLinkArchiveAlertErrorMsg = null;
      if (this.trackingLinkList == null) {
        await this.loadTrackingLinkTemplates();
      }
      this.currentEditLink = this.trackingLinkList.filter((x) => {
        return x._id == linkId;
      });
      this.archiveTrackingLinkModalMsg = `Confirm archive link '${this.currentEditLink[0].name}'?`;
    },
    async loadTrackingLinkTemplates() {
      try {
        this.trackingLinkTemplateLoading = true;
        let loadTrackingLinkTemplateUrl = `${trackingLinkTemplateListApi}/?usertoken=${this.auth}&campaign=${this.candidateData.campaign.campaignId}`;
        //console.log("TRACKING LINK TEMPLATE URL:", loadTrackingLinkTemplateUrl);
        let trackingLinkTemplateResponse = await axios.get(
          loadTrackingLinkTemplateUrl
        );

        if (trackingLinkTemplateResponse.data.success == true) {
          /*console.log(
            "TRACKING LINK RESULTS:",
            trackingLinkTemplateResponse.data
          );*/

          this.trackingLinkTemplateList =
            trackingLinkTemplateResponse.data.result;
          this.trackingLinkTemplateLoading = false;
          return;
        }
        //console.log("FAILED TRACKING LINK LIST", trackingLinkTemplateResponse);
        this.trackingLinkTemplateLoading = false;
      } catch (err) {
        //console.log("THERE WAS AN ERROR:", err);
        this.trackingLinkTemplateLoading = false;
      }
    },
    async loadTrackingLinks() {
      try {
        let loadTrackingLinkUrl = `${trackingLinkReadListApi}/?usertoken=${this.auth}&influencer=${this.candidateId}`;
        //console.log("TRACKING LINK URL:", loadTrackingLinkUrl);
        let trackingLinkResponse = await axios.get(loadTrackingLinkUrl);

        if (trackingLinkResponse.data.success == true) {
          //console.log("TRACKING LINK RESULTS:", trackingLinkResponse.data);
          this.trackingLinkList = trackingLinkResponse.data.result;

          return;
        }
        //console.log("FAILED TRACKING LINK LIST", trackingLinkResponse);
      } catch (err) {
        //console.log("THERE WAS AN ERROR:", err);
      }
    },
    async trackingLinkCreate() {
      //console.log("CREATING TRACKING LINK");
      this.addTrackingLinkErrors = [];
      if (this.newLinkName == null || typeof this.newLinkName == "undefined") {
        this.addTrackingLinkErrors.push("Tracking link name required.");
      }
      if (
        this.newLandingPage == null ||
        typeof this.newLandingPage == "undefined"
      ) {
        this.addTrackingLinkErrors.push("Landing page required.");
      }
      if (this.addTrackingLinkErrors.length > 0) {
        this.addTrackingLinkAlert = true;
        this.alertType = "alert-danger";
        return;
      }
      let newTrackingLink = {};
      newTrackingLink.campaign = this.campaignDetails._id;
      newTrackingLink.influencer = this.candidateId;
      newTrackingLink.landingPage = this.newLandingPage.trim();
      newTrackingLink.usertoken = this.auth;
      newTrackingLink.name = this.newLinkName.trim();
      if (
        this.newUtmSource !== null &&
        typeof this.newUtmSource !== "undefined" &&
        this.newUtmSource.trim() !== ""
      ) {
        newTrackingLink.utmSource = await this.replaceTrackingToken(
          this.newUtmSource
        );
      }
      if (
        this.newUtmCampaign !== null &&
        typeof this.newUtmCampaign !== "undefined" &&
        this.newUtmCampaign.trim() !== ""
      ) {
        newTrackingLink.utmCampaign = await this.replaceTrackingToken(
          this.newUtmCampaign
        );
      }

      if (
        this.newUtmMedium !== null &&
        typeof this.newUtmMedium !== "undefined" &&
        this.newUtmMedium.trim() !== ""
      ) {
        newTrackingLink.utmMedium = await this.replaceTrackingToken(
          this.newUtmMedium
        );
      }

      if (
        this.newUtmTerm !== null &&
        typeof this.newUtmTerm !== "undefined" &&
        this.newUtmTerm.trim() !== ""
      ) {
        newTrackingLink.utmTerm = await this.replaceTrackingToken(
          this.newUtmTerm
        );
      }

      if (
        this.newUtmContent !== null &&
        typeof this.newUtmContent !== "undefined" &&
        this.newUtmContent.trim() !== ""
      ) {
        newTrackingLink.utmContent = await this.replaceTrackingToken(
          this.newUtmContent
        );
      }

      //console.log("SENDING:", newTrackingLink);
      let newTrackingLinkResponse = await axios.post(
        trackingLinkCreateApi,
        newTrackingLink
      );
      //console.log("NEW TRACKING LINK RESPONSE:", newTrackingLinkResponse);
      if (newTrackingLinkResponse.data.success == true) {
        this.newTrackingLinkModal = false;
        await this.loadTrackingLinks();
      }
    },
    async trackingLinkUpdate() {
      //console.log("CREATING TRACKING LINK");
      this.editTrackingLinkErrors = [];
      if (
        this.editLinkName == null ||
        typeof this.editLinkName == "undefined"
      ) {
        this.editTrackingLinkErrors.push("Tracking link name required.");
      }
      if (
        this.editLandingPage == null ||
        typeof this.editLandingPage == "undefined"
      ) {
        this.editTrackingLinkErrors.push("Landing page required.");
      }
      if (this.editTrackingLinkErrors.length > 0) {
        this.editTrackingLinkAlert = true;
        this.alertType = "alert-danger";
        return;
      }
      //console.log("CURRENT EDIT LINK:", this.currentEditLink);
      let updateTrackingLink = {};
      updateTrackingLink.link = this.currentEditLink[0]._id;
      updateTrackingLink.landingPage = this.editLandingPage;
      updateTrackingLink.usertoken = this.auth;
      updateTrackingLink.name = this.editLinkName;
      if (
        this.editUtmSource !== null &&
        typeof this.editUtmSource !== "undefined"
      ) {
        updateTrackingLink.utmSource = this.editUtmSource;
      }
      if (
        this.editUtmCampaign !== null &&
        typeof this.editUtmCampaign !== "undefined"
      ) {
        updateTrackingLink.utmCampaign = this.editUtmCampaign;
      }

      if (
        this.editUtmMedium !== null &&
        typeof this.editUtmMedium !== "undefined"
      ) {
        updateTrackingLink.utmMedium = this.editUtmMedium;
      }

      if (
        this.editUtmTerm !== null &&
        typeof this.editUtmTerm !== "undefined"
      ) {
        updateTrackingLink.utmTerm = this.editUtmTerm;
      }

      if (
        this.editUtmContent !== null &&
        typeof this.editUtmContent !== "undefined"
      ) {
        updateTrackingLink.utmContent = this.editUtmContent;
      }

      //console.log("SENDING:", updateTrackingLink);
      let updateTrackingLinkResponse = await axios.post(
        trackingLinkUpdateApi,
        updateTrackingLink
      );
      //console.log("NEW TRACKING LINK RESPONSE:", updateTrackingLinkResponse);
      if (updateTrackingLinkResponse.data.success == true) {
        this.currentEditLink = null;
        this.editTrackingLinkModal = false;
        await this.loadTrackingLinks();
      }
    },
    async trackingLinkArchive() {
      //console.log("ARCHIVING TRACKING LINK");

      let archiveTrackingLink = {};
      archiveTrackingLink.link = this.currentEditLink[0]._id;

      archiveTrackingLink.status = "archived";
      archiveTrackingLink.usertoken = this.auth;

      //console.log("SENDING:", archiveTrackingLink);
      let archiveTrackingLinkResponse = await axios.post(
        trackingLinkUpdateApi,
        archiveTrackingLink
      );
      //console.log("NEW TRACKING LINK RESPONSE:", archiveTrackingLinkResponse);
      if (archiveTrackingLinkResponse.data.success == true) {
        this.currentEditLink = null;
        this.trackingLinkArchiveAlert = false;
        await this.loadTrackingLinks();
        return;
      }
      this.trackingLinkArchiveAlertErrorMsg =
        "There was an error. Please refresh page.";
    },
    async trackingLinkTemplateSelect() {
      //console.log("EVENT:", this.trackingLinkTemplate);
      //console.log("TEMPLATE LIST:", this.trackingLinkTemplateList);
      let activeTemplate = this.trackingLinkTemplateList.filter((x) => {
        return x._id == this.trackingLinkTemplate;
      });

      if (activeTemplate.length > 0) {
        //console.log("ACTIVE TEMPLATE:", activeTemplate[0]);
        this.newLinkName = activeTemplate[0].name;
        this.newLandingPage = activeTemplate[0].landingPage;

        this.newUtmCampaign = await this.replaceTrackingToken(
          activeTemplate[0].utmCampaign
        );
        this.newUtmSource = await this.replaceTrackingToken(
          activeTemplate[0].utmSource
        );
        this.newUtmMedium = await this.replaceTrackingToken(
          activeTemplate[0].utmMedium
        );
        this.newUtmTerm = await this.replaceTrackingToken(
          activeTemplate[0].utmTerm
        );
      }
    },
    async showArchiveDiscountModal(discountId) {
      try {
        this.discountArchiveAlert = true;
        this.archiveDiscountDetails = this.influencerDiscountList.filter(
          (x) => {
            return x._id == discountId;
          }
        )[0];
        this.discountArchiveAlertErrorMsg = null;
        this.discountArchiveMsg = `Archive discount ${this.archiveDiscountDetails.code}?`;
      } catch (err) {}
    },
    async discountArchive() {
      try {
        //console.log("ARCHIVING TRACKING LINK");

        let archiveDiscount = {};
        archiveDiscount.code = this.archiveDiscountDetails.code;
        archiveDiscount.shop = this.archiveDiscountDetails.store;

        //console.log("SENDING:", archiveTrackingLink);
        let archiveDiscountResponse = await axios.post(
          discountCodeArchiveApi,
          archiveDiscount
        );
        //console.log("NEW TRACKING LINK RESPONSE:", archiveDiscountResponse);
        if (archiveDiscountResponse.data.success == true) {
          this.discountArchiveAlert = false;
          this.archiveDiscountDetails = null;
          await this.loadInfluencerDiscounts();
          return;
        }
        this.discountArchiveAlertErrorMsg =
          "There was an error. Please refresh page.";
      } catch (err) {
        //console.log("THERE WAS AN ERROR:", err);
      }
    },
    async replaceTrackingToken(thisParam) {
      let finalParam = thisParam;
      if (finalParam.indexOf("[[instagram]]") !== -1) {
        finalParam = finalParam.replace(
          "[[instagram]]",
          this.candidateData.instagramProfile
        );
      }
      if (finalParam.indexOf("[[influencer]]") !== -1) {
        finalParam = finalParam.replace("[[influencer]]", this.candidateId);
      }
      if (finalParam.indexOf("[[campaign_name]]") !== -1) {
        finalParam = finalParam.replace(
          "[[campaign_name]]",
          this.campaignDetails.name
        );
      }
      if (finalParam.indexOf("[[campaign]]") !== -1) {
        finalParam = finalParam.replace(
          "[[campaign]]",
          this.campaignDetails._id
        );
      }
      if (finalParam.indexOf("[[campaign_id]]") !== -1) {
        finalParam = finalParam.replace(
          "[[campaign_id]]",
          this.campaignDetails._id
        );
      }
      return finalParam.trim();
    },
    async loadCampaign() {
      try {
        //console.log("HERE IS THE CAMPAIGN ID:", campaignId);
        if (this.candidateData !== null) {
          //console.log("LOADING CANDIDATE ID...", this.candidateData.campaign.campaignId)
          let campaignLoadResponse = await axios.get(
            `${influencerCampaignReadApi}/?usertoken=${this.auth}&campaign=${this.candidateData.campaign.campaignId}`
          );

          if (campaignLoadResponse.data.success === true) {
            this.campaignDetails = campaignLoadResponse.data.result;
            //console.log("CAMPAIGN DETAILS:", this.campaignDetails);
            if (typeof this.campaignDetails.shopId !== "undefined") {
              this.storeExists = true;
              return;
            }
          }
        }
      } catch (err) {
        //console.log("ERR", err);
      }
    },
    async processEvent() {
      //console.log("HERE IS THE EVENT", this.activeEvent);
      if (this.activeEvent.eventData.type === "select") {
        if (this.eventSelectInput !== null) {
          let eventUpdate = {};
          eventUpdate.eventId = this.activeEvent._id;
          eventUpdate.eventInput = this.eventSelectInput;
          eventUpdate.eventStatus = "complete";
          eventUpdate.candidate = this.activeEvent.candidateId;
          eventUpdate.usertoken = this.auth;
          if (this.eventNote !== null) {
            eventUpdate.note = this.eventNote;
          }
          if (this.activeEvent.eventData.endSequence === "true") {
            if (
              this.activeEvent.eventData.endSequenceInput ===
              this.eventSelectInput
            ) {
              eventUpdate.influencerStatus = this.activeEvent.eventData.endSequenceInfluencerStatus;
              eventUpdate.sequenceEnd = true;
            }
          }
          //console.log("EVENT UPDATE:", eventUpdate);
          this.eventSelectModal = false;
          let influencerUpdateEventResponse = await axios.post(
            influencerEventUpdateApi,
            eventUpdate
          );
          //console.log("HERE IS THE RESPONSE: ", influencerUpdateEventResponse);
          if (influencerUpdateEventResponse.data.success === true) {
            this.activeEvent = null;
            this.eventSelectOptions = null;
            this.eventModalLabel = null;
            await this.loadCandidate();
          }
        }

        // RETURN ERROR
      }
      if (this.activeEvent.eventData.type === "confirmation") {
        let eventUpdate = {};
        eventUpdate.eventId = this.activeEvent._id;
        eventUpdate.eventInput = "yes";
        eventUpdate.eventStatus = "complete";
        eventUpdate.candidate = this.activeEvent.candidateId;
        eventUpdate.usertoken = this.auth;
        if (this.eventNote !== null) {
          eventUpdate.note = this.eventNote;
        }
        if (this.activeEvent.eventData.endSequence === "true") {
          if (
            this.activeEvent.eventData.endSequenceInput ===
            this.eventSelectInput
          ) {
            eventUpdate.influencerStatus = this.activeEvent.eventData.endSequenceInfluencerStatus;
            eventUpdate.sequenceEnd = true;
          }
        }
        //console.log("EVENT UPDATE:", eventUpdate);
        this.eventConfirmModal = false;
        let influencerUpdateEventResponse = await axios.post(
          influencerEventUpdateApi,
          eventUpdate
        );
        //console.log("HERE IS THE RESPONSE: ", influencerUpdateEventResponse);
        if (influencerUpdateEventResponse.data.success === true) {
          this.activeEvent = null;
          this.eventSelectOptions = null;
          this.eventModalLabel = null;
          await this.loadCandidate();
        }

        // RETURN ERROR
      }
    },
    noteTypeCheck(event) {
      //console.log(event);
      if (event === null || typeof event === "undefined") {
        return "Select note type.";
      }
      return true;
    },
    noteVisibilityCheck(event) {
      //console.log(event);
      if (event === null || typeof event === "undefined") {
        return "Select note visibility.";
      }
      return true;
    },
    async setProfileType() {
      try {
        if (this.profileStore.isTeam === true) {
          this.isTeam = true;
        }
      } catch (err) {
        //console.log("ERROR:", err);
      }

      try {
        if (this.profileStore.profileTypes.length > 0) {
          if (this.profileStore.profileTypes.indexOf("influencer") !== -1) {
            this.isInfluencer = true;
          }
          if (this.profileStore.profileTypes.indexOf("client") !== -1) {
            this.isClient = true;
          }
        }
      } catch (err) {
        //console.log("ERROR:", err);
      }

      // IF NOT LOADED YET LOAD DIRECTLY TO SET PROFILE TYPE
      //console.log("PROFILE STORE MAIN:", this.profileStore);
      if (this.profileStore === false) {
        let profileLoadResponse = await axios.get(`${userLoadApi}${this.auth}`);
        //console.log("PROFILE DATA MAIN:", profileData.data);
        if (profileLoadResponse.data.success === true) {
          this.profileData = profileLoadResponse.data.result;
          if (profileLoadResponse.data.result.isTeam === true) {
            this.isTeam = true;
          }
          try {
            if (profileLoadResponse.data.result.profileTypes.length > 0) {
              if (
                profileLoadResponse.data.result.profileTypes.indexOf(
                  "influencer"
                ) !== -1
              ) {
                this.isInfluencer = true;
              }
              if (
                profileLoadResponse.data.result.profileTypes.indexOf(
                  "client"
                ) !== -1
              ) {
                this.isClient = true;
              }
            }
          } catch (err) {
            //console.log("ERROR:", err);
          }
        }
      }
    },
    async loadPageContent() {
      this.loadTrackingLinks();
      await this.loadCandidate();
      await this.setProfileType();
      this.loadPosts();
      this.loadPaymentActions();
      this.loadPaymentDetails();
      this.loadCommissionDetails();

      await this.loadCampaign();
      await this.clientStoreCheck();

      if (this.storeExists == true) {
        this.loadInfluencerDiscounts();
      }
    },
  },

  mounted() {
    this.auth = firebase.auth().currentUser.uid;
    this.loadingOverlayText = "Loading...";
    this.candidateId = this.$route.params.candidateId;
    this.loadPageContent();
  },
};
</script>

<style scoped>
.icon-button:hover {
  cursor: pointer;
}
.profile-label {
  text-align: right;
}
.status-complete {
  background-color: green;
  color: white;
}
.note-date {
  font-size: 10px;
  color: gray;
}
.error-note {
  background: red;
  color: white;
  font-weight: bold;
  border-radius: 8px;
  padding: 10px;
  margin: 0px auto 10px auto;
  width: 100%;
}
.post-preview {
  float: left;
  padding: 10px;
  height: 150px;
  width: 150px;
  overflow: hidden;
  cursor: pointer;
}

.img-row {
  object-fit: cover;
}
.influencer-img {
  margin: 10px;
  border-radius: 50%;
}
@import "https://cdn.jsdelivr.net/npm/@voerro/vue-tagsinput@2.0.2/dist/style.css";
</style>
